





function shuffle(array) {
  let currentIndex = array.length;
  while (currentIndex != 0) {
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}


function script_re_run(script_node){
  // Re-runs inline scripts
  // - Find old script parent
  const script_node_parent = script_node.parentElement;
  // - Find old script index from parents children
  const script_index = Array.from(script_node_parent.children).findIndex((script => script === script_node));
  // - Create New Script Element
  const script_node__New = document.createElement("script");
  // - Copy Inner Script
  script_node__New.innerHTML = script_node.innerHTML;
  // - Copy Attributes
  Array.from(script_node.attributes).forEach(attr => {
    script_node__New.setAttribute(attr.name, attr.value);
  });
  // - Delete old script
  script_node.remove();
  // - Add new script
  script_node_parent.insertBefore(script_node__New, script_node_parent.children[script_index])
}







// Custom Notification
function customNotification(html, duration){

  // Remove other notifications
  document.querySelector(".custom_notification.notification_active")?.remove();

  // Create notification
  const notification = document.createElement("span");
  notification.innerHTML = html;
  notification.classList = "custom_notification notification_active notification_hidden";
  document.body.appendChild(notification);
    setTimeout(()=>{
    notification.classList.remove('notification_hidden');
  }, 400);

  // Close Notification Function
  function closeNotification(notification){
    if(!notification.classList.contains("notification_hidden")){
      notification.classList.add("notification_hidden");
      setTimeout(()=>{
        notification.remove();
        window.removeEventListener("scroll", scrollHidesNotification);
      }, 1300);
    }
  };

  // Scroll - Hide Logic
  window.addEventListener("scroll", scrollHidesNotification);
  const currentY = window.scrollY;
  function scrollHidesNotification(mouse) {
    if(window.scrollY > (currentY + 300) || window.scrollY < (currentY - 300)) {
      closeNotification(notification);
    }
  }

  // Autoclose
  setTimeout(()=>{
     closeNotification(notification) 
  }, duration);

}




// Secondary Product Image Swiper Track
document.addEventListener("DOMContentLoaded", ()=> {
  if(document.querySelector("figure.figure_has_secondary .product_imagery_track")) {
    function secondary_initialise_notify(e){
      e.target.closest(".product-card-figure ")?.classList.add("secondary_initialised");
    }

    const wrapper_content = document.querySelector(".page-body-content");
    wrapper_content.addEventListener("click", secondary_initialise_notify);

    let touchMoveHandler, touchEndHandler, initialX, updatedX, finalX, presented_value;

    function startTouchCycle(event) {
        if(event.target.classList.contains("figure_has_secondary") || event.target.closest(".figure_has_secondary") !== null && window.innerWidth < 961) {
          // Store product figure as variable
          var _figure;
          if(event.target.classList.contains("figure_has_secondary")){
            _figure = event.target;
          }
          else if(event.target.closest(".figure_has_secondary")){
            _figure = event.target.closest(".figure_has_secondary");
          }
          var _track = _figure.querySelector("div.product_imagery_track");

          if(_figure.classList.contains("lock") === false) {
            _track.classList.add("is_dragging");
            initialX = event.touches[0].clientX;

            var _current = _track.style.transform;
            if(_current == ""){
              _current = 0;
            }
            else {
              _current = parseInt(_track.style.transform.replace("px)", "").replace("translateX(", ""));
            }

            touchMoveHandler = function (e) {
                updatedX = (e.touches[0].clientX - initialX) / 7;
                updatedX > 30 ? updatedX = 30 : updatedX = updatedX;
                updatedX < -30 ? updatedX = -30 : updatedX = updatedX;
                updatedX = Math.floor(updatedX);
                presented_value = _current + updatedX
                if(presented_value < -100){
                  presented_value = -100;
                }
                else if (presented_value > 0){
                  presented_value = 0;
                }
                _track.style.transform = `translateX(${presented_value}%)`;
              
            };
            
            touchEndHandler = function (e) {
             _current = parseInt(_track.style.transform.replace("px)", "").replace("translateX(", ""));
            _track.classList.remove("is_dragging");
                if(_figure.classList.contains("active")){
                  if(updatedX > 7) {
                    slideProductImage(0, _track, -1, _figure, _current);
                  }
                  else {
                    slideProductImage(-100, _track, 0, _figure, _current);
                  }
                }
                else {
                  if(updatedX < -7) {
                    slideProductImage(-100, _track, 1, _figure, _current);
                  }
                  else {
                    slideProductImage(0, _track, 0, _figure, _current);
                  }
                }
                wrapper_content.removeEventListener('touchmove', touchMoveHandler);
                wrapper_content.removeEventListener('touchend', touchEndHandler);
            };
            wrapper_content.addEventListener('touchmove', touchMoveHandler);
            wrapper_content.addEventListener('touchend', touchEndHandler);
          }
        }
    }
    function slideProductImage(newDistance, track, addActiveClassToFigure, figure, current){
        // Reset to original position
        if(newDistance === 0){
          for(var i=current; i<newDistance; i++){
            track.style.transform = `translateX(${i + 1}%)`;
          }
        }
        // Slide to secondary position
        else {
          for(var i=current; i>newDistance; i--){
            track.style.transform = `translateX(${i - 1}%)`;
          }
        }
        if(addActiveClassToFigure === 1){
          figure.classList.add("active");
        }
        else if(addActiveClassToFigure === -1){
          figure.classList.remove("active");
        }
    }
    wrapper_content.addEventListener('touchstart', startTouchCycle);


    function Product_Item_Changed___Reset_Index(product_item__){
      if(window.innerWidth < 961) {
        const _track = product_item__.querySelector(".product_imagery_track");
        const _figure = product_item__.querySelector("figure");
        const _current = parseInt(_track.style.transform.replace("px)", "").replace("translateX(", ""));
        slideProductImage(0, _track, -1, _figure, _current);
      }
    }
  }
});




let bbv = null;
try {
  class BBVideo {
    constructor(obj) {
      this.init = this.init.bind(this);
      document.addEventListener("DOMContentLoaded", this.init);
      this.video_source;
      this.video_element;
      this.video_container_inner;
      this.video_container_outer;
      this.UI_Panel;
      this.UI_Pause;
      this.UI_Mute;
      this.product_data = [];
    }
    init() {

      this.init_icons_library();

      // Create Video Outer Container
      this.video_container_outer = document.createElement("div");
      this.video_container_outer.style.display = "none";
      this.video_container_outer.id = "bbv_outer";

      document.body.appendChild(this.video_container_outer);

      // Create Video Inner Container
      this.video_container_inner = document.createElement("div");
      this.video_container_inner.id = "bbv_inner";
      this.video_container_outer.appendChild(this.video_container_inner);

      // Create video element
      this.video_element = document.createElement("video");
      this.video_element.id = "bbv_video";
      this.video_element.setAttribute("loop", "true");
      this.video_container_inner.appendChild(this.video_element);

      // Create video source
      this.video_source = document.createElement("source");
      this.video_source.id = "bbv_vid_source";
      this.video_element.appendChild(this.video_source);

      this.add_ui_panel();
    }
    add_ui_panel(){
      
      this.UI_panel = document.createElement("div");
      this.UI_panel.classList = "bbv_UI_panel";
      this.video_container_inner.appendChild(this.UI_panel);

      this.UI_panel.innerHTML = `
      <div class="top">
        <div class="container_left">
          <button class="btn_close" data-bbv-close></button>
        </div>
        <div class="container_right">
        </div>
      </div>
      `;

      this.button__mute = document.createElement("button");
      this.button__mute.classList.add("btn_mute");
      this.button__mute.innerHTML = this.UI_Icon.Mute;
      this.video_container_inner.querySelector(".container_right").appendChild(this.button__mute);
      this.button__mute.addEventListener("click", (e)=> {
        this.UI_Button_Function("Mute");
        e.stopPropagation();
      });

      this.button__pause = document.createElement("button");
      this.button__pause.classList.add("btn_pause");
      this.button__pause.classList.add("active");
      this.button__pause.innerHTML = this.UI_Icon.Pause;
      this.video_container_inner.querySelector(".container_right").appendChild(this.button__pause);
      this.button__pause.addEventListener("click", (e)=> {
        this.UI_Button_Function("Pause");
        e.stopPropagation();
      });



      
      // Handle auto mute/nomute on page load
      this.muted_node = true;
      localStorage.getItem("muted_mode") == "false" ? this.muted_node = false : this.muted_node = true;
      (!this.muted_node) ? this.UI_Button_Function("Mute", false) : this.UI_Button_Function("Mute", true)



    }
    add_trigger_button(node){
      const ref = this;
      try {
        if(!node.hasAttribute("data-vid-source")){
          throw new Error("'data-vid-source' is missing from trigger button");
        }

        node.addEventListener("click", function(e){
          const node_item = e.currentTarget;
          const obj = {};
          obj.source = node_item.getAttribute("data-vid-source");
          obj.hasNoAudio = node_item.getAttribute("data-vid-has-no-audio");
          ref.update_video(obj);
        });
      }
      catch(err){
        console.error("Error on BBVideo", err, node);
        node.style.display = "none";
      }
    }
    update_video(obj){
      if((obj.source === this.video_source.getAttribute("src")) == false || (!this.video_container_outer.classList.contains("show"))) {
        this.video_source.setAttribute("src", obj.source);
        this.video_element.currentTime = 0;
        this.video_element.load();
        this.video_element.play();
        if(obj.hasNoAudio || obj.source.includes("noaudio")) {
          this.button__mute.style.opacity = "0";
          this.button__mute.style.pointerEvents = "none";
        }
        else {
          this.button__mute.style.opacity = "";
          this.button__mute.style.pointerEvents = "";
        }


      }
      if(!this.video_container_outer.classList.contains("show")) {
        this.display_video(true);
      }
    }
    display_video(bool) {
      if(bool) {
        setTimeout(() => {
          this.video_container_outer.style.display = "";
        }, 10);
        setTimeout(() => {
          this.video_container_outer.classList.add("show");
        }, 50);
        document.addEventListener("click", this.monitor_click_e);
        this.scrollY_on_launch = window.scrollY;
        document.addEventListener("scroll", this.monitor_scroll_e);
      }
      else {
        setTimeout(() => {
          this.video_container_outer.classList.remove("show");
        }, 10);
        setTimeout(() => {
          this.video_container_outer.style.display = "none";
        }, 300);
        this.video_element.pause();
        document.removeEventListener("click", this.monitor_click_e);
        document.removeEventListener("scroll", this.monitor_scroll_e);
      }

    }
    monitor_click_e = (e) => {
      if(this.video_container_outer.classList.contains("show")) {
        let has__bbv_outer;
        e.target.closest("#bbv_outer") ? has__bbv_outer = true : has__bbv_outer = false;
        if(!has__bbv_outer) {
          if(e.target.hasAttribute("data-vid-source")){
            has__bbv_outer = true;
          }
        }
        if(!has__bbv_outer || e.target.closest("[data-bbv-close]")){
          this.display_video(false);
        }
      }
      if(e.target === this.video_element) {
        if(this.video_element.paused === true) {
          this.UI_Button_Function("Pause", false);
        }
        else {
          this.UI_Button_Function("Pause", true);
        }
      }
    }
    monitor_scroll_e = (e) => {
      var max_scroll_limit;
      window.innerWidth < 700 ? max_scroll_limit = 70 : max_scroll_limit = 250;
      if((Math.abs(window.scrollY - this.scrollY_on_launch) > max_scroll_limit)) {
        this.display_video(false);
      }
    }

    init_icons_library(){
      this.UI_Icon = {};
      this.UI_Icon.Pause = `<svg viewBox="0 0 30 30"><polygon class="State1" points="11 7 22 15 11 23 11 7"/>   <path class="State2" d="M20,8v14h-3v-14h3ZM11,22h3v-14h-3v14Z"/> </svg>`;
      this.UI_Icon.Mute = `<svg viewBox="0 0 30 30"><path class="State1" d="M14.8,8v13.9c0,.4-.5.6-.7.4l-4.2-4.3h-3c-.3,0-.8-.5-.8-.7v-4.5c0-.3.5-.7.9-.7h3l4.2-4.4c.3-.2.7,0,.7.4ZM17.9,11.4c-.2-.3-.5-.3-.7-.1-.2.2-.3.5-.2.7.6.9.9,1.9.9,2.9s-.3,2-.9,2.9c-.2.2,0,.6.2.7h.3c.2,0,.3,0,.4-.2.7-1,1.1-2.2,1.1-3.5s-.4-2.5-1.1-3.5h0ZM19.7,9.8c-.2-.2-.5-.2-.7,0s-.2.5,0,.7c1,1.4,1.7,2.9,1.7,4.5s-.6,3.2-1.7,4.5c-.2.2-.2.6,0,.7s.2.2.3.2.3,0,.4-.2c1.2-1.5,1.9-3.3,1.9-5.2s-.7-3.7-1.9-5.2h0ZM21.3,8.1c-.2-.1-.5-.2-.7,0-.2.2-.2.5,0,.7,1.6,1.8,2.4,3.8,2.4,6.1s-.8,4.4-2.4,6.1c-.2.2-.2.5,0,.7.2,0,.2.2.4.2s.2,0,.3-.3c1.8-2,2.7-4.3,2.7-6.7s-1-4.8-2.7-6.8Z"/><path class="State2" d="M9,7.5l13.5,15h-1.5L7.5,7.5h1.5ZM14.8,8c0-.4-.4-.6-.7-.4l-1.8,1.9,2.5,2.7v-4.3h0ZM9.9,12h-3c-.4,0-.9.5-.9.7v4.5c0,.3.5.7.8.7h3l4.2,4.3c.3.2.7,0,.7-.4v-4.8l-4.8-5.2h0ZM18,14.9v.8l.8.9c.2-.5.2-1.1.2-1.7,0-1.3-.4-2.5-1.1-3.5-.2-.3-.5-.3-.7-.1-.2.2-.3.5-.2.7.6.9.9,1.9.9,2.9ZM20.5,14.9c0,1-.2,2-.7,2.9l.7.8c.6-1.1.9-2.4.9-3.7,0-1.9-.7-3.7-1.9-5.2-.2-.2-.5-.2-.7,0s-.2.5,0,.7c1,1.4,1.7,2.9,1.7,4.5h0ZM23,14.9c0,1.7-.5,3.4-1.4,4.8l.6.7c1.2-1.7,1.7-3.6,1.7-5.5s-1-4.8-2.7-6.7c-.2-.1-.5-.2-.7,0-.2.2-.2.5,0,.7,1.6,1.8,2.4,3.8,2.4,6.1h0Z"/></svg>`;
    }
    UI_Button_Function(type, force){
      switch (type) {
        case "Pause" : {
          if(this.video_element.paused) {
            this.button__pause.classList.add("active");
            this.video_element.play();
            this.emit_pause_icon("Play");
          }
          else {
            this.button__pause.classList.remove("active");
            this.video_element.pause();
            this.emit_pause_icon("Pause");
          }
          break;
        }
        case "Mute" : {

          const mute = (bool) => {
            if(bool) {
              this.button__mute.classList.add("active");
              setTimeout(() => {
                this.video_element.volume = 0;
                this.muted_node = true;
                localStorage.setItem("muted_mode", "true");
              }, 100);

            }
            else {
              this.button__mute.classList.remove("active");
              setTimeout(() => {
                this.video_element.volume = 1;
                this.muted_node = false;
                localStorage.setItem("muted_mode", "false");
              }, 100);

            }
          }

          if(force === true) {
            mute(true);
          }
          else if(force === false) {
            mute(false);
          }
          else if(this.muted_node == true) {
            mute(false);
          }
          else {
            mute(true);
          }
          break;
        }
      }
    }

    emit_pause_icon(type) {
      const icon_emitter = document.createElement("div");
      if (this.temp_emitter_ref instanceof HTMLElement) {
        this.temp_emitter_ref.remove();
        this.temp_emitter_ref = null;
      }
      this.temp_emitter_ref = icon_emitter;
      icon_emitter.classList.add("emit_pause_play");
      Object.assign(icon_emitter.style, {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "30%",
        opacity: "0.5",
        height: "auto",
        pointerEvents: "none",
        transition: "all 0.65s ease",
      });
      if(type === "Pause") {
        icon_emitter.innerHTML = `<svg style="width: 100%; height: auto;" viewBox="0 0 150 150"><path fill="#fff" d="M75,0C33.6,0,0,33.6,0,75s33.6,75,75,75,75-33.6,75-75S116.4,0,75,0ZM68,99.9c0,2.3-1.8,4.1-4.1,4.1h-8.8c-2.3,0-4.1-1.8-4.1-4.1v-49.8c0-2.3,1.8-4.1,4.1-4.1h8.8c2.3,0,4.1,1.8,4.1,4.1v49.8ZM99,99.9c0,2.3-1.8,4.1-4.1,4.1h-8.8c-2.3,0-4.1-1.8-4.1-4.1v-49.8c0-2.3,1.8-4.1,4.1-4.1h8.8c2.3,0,4.1,1.8,4.1,4.1v49.8Z"/></svg>`;
      }
      else if(type === "Play") {
        icon_emitter.innerHTML = `<svg style="width: 100%; height: auto;" viewBox="0 0 150 150"><path fill="#fff" d="M75,0C33.6,0,0,33.6,0,75s33.6,75,75,75,75-33.6,75-75S116.4,0,75,0ZM103.8,79.7l-39.1,22.6c-3.6,2.1-8.2-.5-8.2-4.7v-45.1c0-4.2,4.5-6.8,8.2-4.7l39.1,22.6c3.6,2.1,3.6,7.3,0,9.4Z"/></svg>`;
      }
      this.video_container_inner.appendChild(icon_emitter);
      setTimeout(()=> {
        icon_emitter.style.width = "50%";
        icon_emitter.style.opacity = "0";
      }, 10);
      setTimeout(()=> {
        icon_emitter.remove();
        this.temp_emitter_ref = null;
      }, 510);
    }

  }

  bbv = new BBVideo;

}
catch(err){
  console.log("Error with BBV:");
  console.log(err);
}









// Ipad/Tablet Touch Fix On Menu > Dont Link To Page, Instead Open Child Mega Nav

const evt = new Event("look", {"bubbles":true, "cancelable":false});
document.dispatchEvent(evt);

document.addEventListener("DOMContentLoaded", function() {
  if (document.documentElement.classList.contains("has-touch")) {
    const labels = document.querySelectorAll(".main-header--nav-links li.has-mega-nav .label");
    labels.forEach(function(label) {
      label.removeAttribute("href");
    });
  }
});




class Core_Cart {

  constructor() {

  }

  add(data, success_callback, failure_callback) {
 /* Add a single item to the cart

 data = 'items': [{
  'id': 36110175633573,
  'quantity': 2
  }]
*/
    if(success_callback){
      this.core_cart__OnUpdate_Success = success_callback;
    }
    if(failure_callback){
      this.core_cart__OnUpdate_Failure = failure_callback;
    }
    this.post_data('cart/add.js', data, success_callback, failure_callback);
  }
  update(data, success_callback, failure_callback) {
/* Updates the cart with variant_id to quantity

    data = {
      794864053: 2,
      794864233: 3
    }
*/
    if(success_callback){
      this.core_cart__OnUpdate_Success = success_callback;
    }
    if(failure_callback){
      this.core_cart__OnUpdate_Failure = failure_callback;
    }
    this.post_data('cart/update.js', data, this.core_cart__OnUpdate_Success, this.core_cart__OnUpdate_Failure);
  }

  /* Fetch  =>  Post Data */
  post_data(destination, data, success_callback, failure_callback) {
    fetch(window.Shopify.routes.root + destination, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      return response.json().then(json => ({
        status: response.status,
        json
      }));
    })
    .then(({status, json}) => {
      if (status >= 200 && status < 300) {
        if (success_callback) success_callback(json);
      }
      else {
        if (failure_callback) failure_callback(json);
      }
    })
    .catch((error) => {
      if (failure_callback) failure_callback(error);
      console.error('Error:', error);
    });
  }

}





// Calls the Core_Cart object by passing in the variables which are stored in the objects select sibling/button attribute
function product_item_add_to_cart(e, notify_reset){
  // Queries whether product_item has select box parent '._product-select-option'. Else if not, gets variant ID from attribute '[variant_id]'

  // Init
  var v_id = e.getAttribute("variant_id");
  const parent_block = e.closest(".product-item__");
  if(parent_block?.querySelector("._product-select-option")){
    v_id = parent_block.querySelector("._product-select-option").value;
  }



  // Add To Cart
  
    Master_Cart.add_items([{
      'id': v_id,
      'quantity': 1
    }], added_success, added_fail);
  



  // Success Callback
  function added_success() {
    const original_text = e.innerText;
    e.classList.add("item_added");
    if(!e.hasAttribute("data-original-text")){
      e.setAttribute("data-original-text", e.innerText);
    }
    e.innerText = "Toegevoegd";
    if(notify_reset === true) {
      setTimeout(()=>{
        e.classList.remove("item_added");
        e.innerText = e.getAttribute("data-original-text");
      }, 2000);
    }

    // customNotification("Lorem ipsum dolor set", 1500);
  }

  // Fail Callback
  function added_fail(err) {
    console.log(err.description);
  }

}


//handle change on a select and update that products price options
/*
$( document ).ready(function() {
  
    $.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      return results[1] || 0;
  	}
  
  $('.product-card-details select').change( function() {
    //determine if the product has a sale price
    if ( $( this ).children("option:selected").attr("data-price-sale") != null ) {
      $('#product-card-' + $( this ).children("option:selected").attr("data-productID") + ' .price span.money').html($( this ).children("option:selected").attr("data-price-regular"));
      $('#product-card-' + $( this ).children("option:selected").attr("data-productID") + ' .price.sale span.money').html($( this ).children("option:selected").attr("data-price-sale"));
    } else {
      $('#product-card-' + $( this ).children("option:selected").attr("data-productID") + ' .price span.money').html( $( this ).children("option:selected").attr("data-price-regular") );
    }
  });

});
*/

// Reorder Desktop and Mobile Navs, price highest (via CSS Flex)
document.addEventListener("DOMContentLoaded", ()=> {
  var styleTag_content = "";
  if(document.querySelector("#desktop_menu")) {
      const desktop_menu = document.querySelector("#desktop_menu");
      const desktop_list_items = desktop_menu.querySelectorAll(".priceHigh .list-item");
      styleTag_content = "#cmm_links_container li.link_title {order: -1;}";
      desktop_list_items.forEach(node => {
        if(node.hasAttribute("data-price") && node.hasAttribute("data-collection-handle")) {
          data_collec_handle_query = "[data-collection-handle=" + node.getAttribute("data-collection-handle") + "]";
          let price_order = node.getAttribute("data-price");
          price_order = price_order.replace(".", "");
          price_order = price_order.replace(",", "");
          styleTag_content += `#desktop_menu .header_accordion_panel .list-item${data_collec_handle_query}, #custom_mobile_menu .last_level_dropdown .list-item${data_collec_handle_query} {order: ${price_order};}`;
        }
      })
  }
  if(styleTag_content != "") {
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-from", "injected_via_mainJS");
    styleTag.innerHTML = styleTag_content;
    document.querySelector("#desktop_menu").appendChild(styleTag);
  }
});




// Custom select boxes
/* Add attribute of 'data-pre-img' with image URL for image to display on each option */

function watchCustomSelectClick(event){
  // Check if any select menus are visible
  if(document.querySelectorAll(".select_menu_show").length != 0) {
    // Hide all select menus if click is not on a select menu
    if(event.target.closest(".custom_select_") == null) {
      document.querySelectorAll(".select_menu_show").forEach(i => i.classList.remove("select_menu_show"))
    }
  }
  if(event.target.classList.contains("custom_select_menu_close")) {
      document.querySelectorAll(".select_menu_show").forEach(i => i.classList.remove("select_menu_show"))
  }

  if(event.target.closest(".custom_select_option")!= null && event.target.closest(".custom_select_option").getAttribute("disabled")!= "true") {
    // Change Visual Text
    event.target.closest(".custom_select_").querySelector(".custom_select_button_ ").innerText = event.target.closest(".custom_select_option").querySelector("span.content").innerText;

    // Update Select Value
    event.target.closest(".custom_select_").parentNode.querySelector("select").value = event.target.closest(".custom_select_option").getAttribute("custom_value");;
    event.target.closest(".custom_select_").parentNode.querySelector("select").dispatchEvent(new Event("change"));

    // Add Active Class To Option
    event.target.closest(".custom_select_menu_").querySelectorAll(".custom_select_option").forEach(i=>i.classList.remove("active"));
    event.target.closest(".custom_select_option").classList.add("active");
    
  }
}
document.addEventListener("click", watchCustomSelectClick);

class CustomSelect {
    constructor(selectTarget, preHTML, postHTML, addedClassName) {
        this.target = document.querySelectorAll(selectTarget);
        this.targetLength = document.querySelectorAll(selectTarget).length;
        this.preHTML = preHTML;
        this.postHTML = postHTML;
        this.addedClassName = addedClassName;
        this._ii_ = [0,0,0]; // Iteration Integer In For Loop;
        this.customSelectBoxes = "";
    }

    createDivSelect(){
//   [0] = All Select Box's  |  [1] = All Select Option's  |  [2] = All Select Attributes

    /* Define Custom Select Div */

      // Forloop on all of the select boxes with the matching query selector
      for(this._ii_[0]=0; this._ii_[0]<this.target.length; this._ii_[0]++){


        // HTML Variable - Add the display select box as well as the opening div for the select menu
        let customStylingSelector = `<div class="custom_select_ ${this.addedClassName}"><div class='custom_select_button_'>${this.target[this._ii_[0]].selectedOptions[0].innerHTML}</div><div class="custom_select_menu_close" style="display: none;"></div><div class='custom_select_menu_'>`;

            // HTML Variable - For each of the select options in the select box
            for(this._ii_[1]=0; this._ii_[1]<(this.target[this._ii_[0]].length); this._ii_[1]++) {

              // HTML Variable - Add the select options attributes to the new custom div option
              let att = ""; 
              let pre_img = "";
              let content = "";
              for(this._ii_[2]=0; this._ii_[2] < this.target[this._ii_[0]][this._ii_[1]].attributes.length; this._ii_[2]++){
                if(this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].name == "value"){
                  att += `custom_value="${this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].value}" `
                }
                else if(this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].name == "disabled") {
                  att += `disabled="true" `
                }
                else if(this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].name == "data-pre-img") {
                  pre_img = `<img src="${this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].value}">`
                }
                else {
                  att += `${this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].name}="${this.target[this._ii_[0]][this._ii_[1]].attributes[this._ii_[2]].value}" ` 
                }
              }

              // HTML Variable - Add the final new custom select option
              customStylingSelector += `<div class="custom_select_option" ${att}>${this.preHTML}${pre_img}<span class="content">`;

              // Remove Sold Out
              content = this.target[this._ii_[0]][this._ii_[1]].innerHTML.replaceAll("Uitverkocht", "<span class='sold_out'>Uitverkocht</span>");
              
              customStylingSelector += `${content}</span>${this.postHTML}</div>`;
            }
        
            customStylingSelector += "</div>";
        
            // Add the new custom display box after the original select box
            this.target[this._ii_[0]].insertAdjacentHTML("afterend", customStylingSelector);

            // Hide Original Menu
            this.target[this._ii_[0]].style.display = "none";

            // Add Active To First Element       
            this.target[this._ii_[0]].nextElementSibling.querySelectorAll(".custom_select_option").forEach(i => i.innerText == this.target[this._ii_[0]].selectedOptions[0].innerText ? i.classList += " active" : "")

        }
    }

    onClickLogic() {
      for(this._ii_[0]=0; this._ii_[0]<this.target.length; this._ii_[0]++){
        const customSelect = this.target[this._ii_[0]].parentNode.querySelector(".custom_select_button_");
        const customSelectMenu = this.target[this._ii_[0]].parentNode.querySelector(".custom_select_menu_");

        // Show / Hide
        customSelectMenu.addEventListener("click", function(){
          if(customSelectMenu.classList.contains("select_menu_show")){
            customSelectMenu.classList.remove("select_menu_show");
          }
        })
        customSelect.addEventListener("click", function(){
          if(customSelectMenu.classList.contains("select_menu_show")){
            customSelectMenu.classList.remove("select_menu_show");
          }
          else {
            document.querySelectorAll(".select_menu_show").forEach(i => i.classList.remove("select_menu_show"));
            customSelectMenu.classList.add("select_menu_show");
          }
        })
      }
    }
    functionHook() {
      
    }
    run(){
      this.createDivSelect();
      this.onClickLogic();
      this.functionHook();
    }
}



// Read More Global - ACTUALLY NOT SURE IF EVEN IN USE
document.addEventListener("DOMContentLoaded", () => {
  const g__read_more = Array.from(document.querySelectorAll(".g__read_more"));
  const g__read_more_fctn = function() {
    const content = this.querySelector(".g__read_more_content");
    if (content && content.offsetHeight > 100) {
      this.classList.add("unshown");
      const trigger = document.createElement("span");
      trigger.className = "g__read_more_trigger";
      trigger.textContent = "Lees verder";
      trigger.addEventListener("click", function() {
        this.closest(".g__read_more").classList.remove("unshown");
        this.style.display = "none";
      });
      this.appendChild(trigger);
    }
  };
  for (let i = 0; i < g__read_more.length; i++) {
    g__read_more_fctn.apply(g__read_more[i]);    
  }
});






  

    // Filter Styling
    function changeColours(){
      var c_parent, cfw;
      if(document.querySelector(".collection__filters")) {
        c_parent = document.querySelector(".collection__filters");
        cfw = ".collection-filters__details-wrapper";
      }
      else if (document.querySelector(".search__filters")) {
        c_parent = document.querySelector(".search__filters");
        cfw= ".search-filters__details-wrapper";
      }
      if(c_parent){
        let colourCount = 0;
        function changeColoursFn(label, hex){
          if(c_parent.querySelector(`.value_${label} .label_`) !== null ){
            c_parent.querySelector(`.value_${label} .label_`).innerHTML = `<span class="colour_" style="background: ${hex}"></span>` + c_parent.querySelector(`.value_${label} .label_`).innerHTML;
            colourCount++;
            if(colourCount === 1){
              document.querySelector(`.value_${label} .label_`)?.closest(cfw)?.classList.add("colourSelector")
            }
          }
        };changeColoursFn("Blauw", "#194a75");
        changeColoursFn("Rood", "#bd2036");
        changeColoursFn("Groen", "#22a13d");
        changeColoursFn("Geel", "#e8eb38");
        changeColoursFn("Grijs", "#9d9d9d");
        changeColoursFn("Zwart", "#1c1c1c");
        changeColoursFn("Wit", "#fff");
        changeColoursFn("Roze", "#f959b5");
        changeColoursFn("Paars", "#9b56e7");
        changeColoursFn("Neutrale", "#dbcdc2");
        changeColoursFn("Bruin", "#7e522f");
        changeColoursFn("Oranje", "#f59441");
        changeColoursFn("Veelkleurig", "linear-gradient(90deg, #e5bd2e 20%, #d94741 20% 40%, #2e974e 40% 60%, #147d8f 60% 80%, #1c2383 80%)");
        
      }
    };
    
    document.addEventListener("DOMContentLoaded", changeColours);// Live Search

document.addEventListener("DOMContentLoaded", ()=> {

  const search_container = document.getElementById("search_container");
  const search_trigger_desktop = document.getElementById("search_trigger_desktop");
  const mobile_search_icon = document.getElementById("mobile_search_icon");
  const search_container_close = document.getElementById("search_container_close");
  const search_element_form = document.getElementById("search_element_form");
  const search_element_form_clear_input = document.getElementById("search_element_form_clear_input");
  const search_element_suggested_strings = document.getElementById("search_element_suggested_strings");
  const search_element_form_input_field = document.getElementById("search_element_form_input_field");
  const search_dimmer = document.getElementById("search_dimmer");

  search_trigger_desktop.addEventListener("click", search_show);
  mobile_search_icon.addEventListener("click", search_show);
  search_container_close.addEventListener("click", search_hide);
  search_element_form_clear_input.addEventListener("click", clear_search_input_field);
  search_element_suggested_strings.addEventListener("click", search_string_click);
  search_dimmer.addEventListener("click", search_hide);
  
  function search_show(){
    search_container.style.display = "";
    if(search_element_form_clear_input.closest("#mobile_search_panel") === null) {
      document.body.style.overflow = "hidden";
    }
    // Focus on search box when clicked
    document.querySelector("#search_element_form_input_field")?.focus();
  }
  function search_hide(){
    search_container.style.display = "none";
    if(search_element_form_clear_input.closest("#mobile_search_panel") === null) {
      document.body.style.overflow = "";
    }
  }
  function clear_search_input_field(){
    if(search_element_form_input_field.value === ""){
      if(search_element_form_clear_input.closest("#mobile_search_panel") === null) {
        search_hide();
      }
    }
    else {
      search_element_form_input_field.value = "";
    }
  }
  function search_string_click(e) {
    if(e.target.closest(".suggested_search")){
      search_element_form_input_field.value = e.target.closest(".suggested_search").innerText;
    }
    search_element_form.submit();
  }
  
});




// Wishlist Functionality - Products
function wishlist_init() {
  const wishlistButtons = document.querySelectorAll(".c__wishlist");
  
  if (wishlistButtons.length === 0) return;

  let wishlisted_products = [];

  // Load existing wishlist from localStorage
  const storedWishlist = localStorage.getItem("wishlist_products");
  if (storedWishlist) {
    wishlisted_products = JSON.parse(storedWishlist);

    // Update UI for all wishlist buttons
    wishlistButtons.forEach(button => {
      const productHandle = button.getAttribute("data-product-handle");
      if (wishlisted_products.includes(productHandle)) {
        button.classList.add("added");
      } else {
        button.classList.remove("added");
      }
    });
  }

  // Add click handlers to all wishlist buttons
  wishlistButtons.forEach(button => {
    button.addEventListener("click", function() {
      const productHandle = this.getAttribute("data-product-handle");
      const allMatchingButtons = document.querySelectorAll(`.c__wishlist[data-product-handle="${productHandle}"]`);

      if (wishlisted_products.includes(productHandle)) {
        // Remove from wishlist
        wishlisted_products = wishlisted_products.filter(e => e !== productHandle);
        allMatchingButtons.forEach(btn => btn.classList.remove("added"));
        customNotification(`Artikel verwijderd van je verlanglijst <a href='/pages/verlanglijst'>Verlanglijst</a>`, 3000);
      } else {
        // Add to wishlist
        wishlisted_products.push(productHandle);
        allMatchingButtons.forEach(btn => btn.classList.add("added"));
        customNotification(`Artikel toegevoegd aan je verlanglijst <a href='/pages/verlanglijst'>Verlanglijst</a>`, 3000);
      }

      // Update localStorage
      if (wishlisted_products.length > 0) {
        localStorage.setItem('wishlist_products', JSON.stringify(wishlisted_products));
      } else {
        localStorage.removeItem('wishlist_products');
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", wishlist_init);




function accordion_desktop_menu(){
  if(document.querySelector(".header_accordion_nav")){

    // Make Tabs Left Aligned
    document.getElementById("desktop_menu").classList.add("left_aligned_tabs");
    const nav_areas = Array.from(document.querySelectorAll(".header_accordion_nav .header_accordion_nav-inner"));

    nav_areas.forEach(nav_area => {
      const nav_elements = nav_area.querySelectorAll(".header_accordion_nav_element");
      if((!nav_area.querySelector(".nav_container")) && nav_elements.length > 0){
        const container = document.createElement("div");
        container.classList.add("nav_buttons_container");

        for(const item of nav_elements) {
          container.appendChild(item);
        }

        nav_area.insertBefore(container, nav_area.children[0]);
      }
    });

    document.getElementById("desktop_menu").addEventListener("click", (e)=>{

      if(e.target.closest(".header_accordion_nav_element") && !e.target.closest(".header_accordion_nav_element").classList.contains("active")){

        // Init
        const nav_btn_target = e.target.closest(".header_accordion_nav_element");
        const nav_container = nav_btn_target.closest(".accordion_container");
        const nav_btns = nav_container.getElementsByClassName("header_accordion_nav_element");
        const accordion_panels = nav_container.getElementsByClassName("header_accordion_panel");
        const handle_name = nav_btn_target.getAttribute("data-handle-trigger");

        // Accordion Nav Highlight
        for(var i = 0; i < nav_btns.length; i++) {
          nav_btns[i].classList.remove("active")
        }
        nav_btn_target.classList.add("active");

        // Accordion Panel Display
        for(var i = 0; i < accordion_panels.length; i++) {
          if(accordion_panels[i].id === ('panel_' + handle_name)) {
            accordion_panels[i].classList.add("active");
          }
          else {
            accordion_panels[i].classList.remove("active");
          }
        }

      }
    });

  }
}
function meganav_hover(){
  const desktop_menu = document.getElementById("desktop_menu");
  const targets = (Array.from(desktop_menu.getElementsByClassName("nav-item"))).concat(Array.from(desktop_menu.getElementsByClassName("mega-nav")));
  for(var i = 0; i < targets.length; i++){
    targets[i].addEventListener("mouseover", mega_active);
    targets[i].addEventListener("mouseleave", mega_unactive);
  }
  function mega_active(e) {
    const li = e.target.closest("li.nav-item");
    const meganav_section = li.getElementsByClassName("mega-nav")[0];
    const details = li.querySelector("details");
    if(!e.target.closest("li.nav-item").classList.contains("active") && meganav_section) {
      li.classList.add("active");
      meganav_section.classList.add("visible");
      if(details){
        details.setAttribute("data-nav-details", "");
        details.setAttribute("open", "");
      }
    }
  }
  function mega_unactive(e) {
    const li = e.target.closest("li.nav-item");
    const meganav_section = li.getElementsByClassName("mega-nav")[0];
    const details = li.querySelector("details");
    if(e.target.closest("li.nav-item").classList.contains("active")) {
      li.classList.remove("active");
      meganav_section.classList.remove("visible");
      if(details){
        details.removeAttribute("open")
        details.removeAttribute("data-nav-details");
      }
    }
  }
}
document.addEventListener("DOMContentLoaded", ()=> {
  // Custom Functions
  meganav_hover();
  // Core Functions
  accordion_desktop_menu();
});






"use strict";






class Swatch_Render {

  /* Parameter is an options object:
  {
    url_list: {Array of URLs} [".../collections/collection-name/products.json?limit=50&page=1", ".../collections/collection-name/products.json?limit=50&page=2"]
    fabric_json: {JSON}
    container_element: {String (query selector)} Used to inject data into
    current_product_handle: {String} Used to detect which is active
    breadcrumb_parent_handle: {String} Used to hold the data for the swatches to allow multiple instances ~ for JSON keys, replace '-' with '_'
    render_type: {String} Option of 'product-main', or 'product-item'
    script_caller_node: {String} Option of 'product-main', or 'product-item'
  }
  */

  constructor(options){
    this.url_list = options.url_list || [];
    this.fabric_json = options.fabric_json || {};
    this.collection_products = [];
    this.breadcrumb_parent_handle = options.breadcrumb_parent_handle || "";
    this.container = document.querySelector(options.container_element) || null;
    this.render_type = options.render_type || "";
    this.current_product_handle = options.current_product_handle || "";
    this.collection_data_fulfilled = 0;
    this.collection_data_expected = 0;
    this.queried_collections = [];
    this.yoinked_items = [];
    this.final_output_json = {
      [this.breadcrumb_parent_handle]: {
        "fabrics": [],
        "swatches": []
      }
    };
    this.script_caller_node = options.script_caller_node;
    this.tooltip_img_size = "_120x120.jpg";
    this.fabric_img_size = "_120x120.jpg";
    this.product_item_preview_img_size = "_550x550.jpg";
    this.master_check_throttle_allow = true;
    this.master_check_interval = false;
    this.elaborate_fabric_labels = options.elaborate_fabric_labels;
    this.elaborate_fabric_labels_change_page_on_click = options.elaborate_fabric_labels_change_page_on_click;
    this.elaborate_fabric_labels_show_price_diff = options.elaborate_fabric_labels_show_price_diff;
    this.fabric_metaobject = options.fabric_metaobject,
    this.product_main_ready_callback = options.product_main_ready_callback;
    this.package_and_send();
  }

  update(new_options) {
    this.url_list = new_options.url_list || this.url_list;
    this.fabric_json = new_options.fabric_json || this.fabric_json;
    this.breadcrumb_parent_handle = new_options.breadcrumb_parent_handle || this.breadcrumb_parent_handle;
    this.container = document.querySelector(new_options.container_element) || this.container;
    this.render_type = new_options.render_type || this.render_type;
    this.current_product_handle = new_options.current_product_handle || this.current_product_handle;
    this.final_output_json[this.breadcrumb_parent_handle] = this.final_output_json[this.breadcrumb_parent_handle] ? this.final_output_json[this.breadcrumb_parent_handle] : this.final_output_json[this.breadcrumb_parent_handle] = {"fabrics": [], "swatches": []};
    this.script_caller_node = new_options.script_caller_node;
    this.package_and_send();
  }

  package_and_send() {
    /* Due to the asynchronous nature of this class with multiple instances, we must package all of
    the swatch local data and send them as isolated parameters to avoid confusion and conflictions
    with the fetch result comparing to data which is relevant to another swatch collection */

    var associated_by = "null";
    if((this.fabric_json.hasOwnProperty("config") && this.fabric_json.config.hasOwnProperty("associateBy"))) {
      associated_by = this.fabric_json.config.associateBy;
    }
  
    const packaged_data = {
      "url_list" : this.url_list,
      "fabric_json" : this.fabric_json,
      "collection_products" : this.collection_products,
      "breadcrumb_parent_handle" : this.breadcrumb_parent_handle,
      "container" : this.container,
      "render_type" : this.render_type,
      "current_product_handle" : this.current_product_handle,
      "final_output_json" : this.final_output_json,
      "associated_by": associated_by,
      "parsed_urls" : 0,
      "script_caller_node": this.script_caller_node,
      "failure": false,
      "injected": false,
      "post_ajax_fetch": false
    }

    this.start(packaged_data);
  }

  start(packaged_data){

    if(packaged_data.render_type == "product-main") {
      packaged_data.swatch_fabrics_container = packaged_data.container.querySelector(".swatch_area_fabrics__main");
      packaged_data.swatch_colours_container = packaged_data.container.querySelector(".swatch_area_colours__main");
      this.fetch_url_based_json(packaged_data.url_list, packaged_data);
    }
    else if(packaged_data.render_type == "product-item") {

      if(packaged_data.script_caller_node.getAttribute("data-injected") == "true") {
        packaged_data.injected = true;
      }

      // First check if we already have fetched/stored this data
      var proceed = false;
      if(!this.queried_collections.includes(packaged_data.breadcrumb_parent_handle)) {
        proceed = true;
      }
      if(proceed === true) {
        this.collection_data_expected = this.collection_data_expected + 1;
        this.fetch_url_based_json(packaged_data.url_list, packaged_data);
        if(packaged_data.injected == true) {
          packaged_data.post_ajax_fetch = true;
        }
      }
      else {
        // For Injected scripts after page load
        if(packaged_data.injected == true) {
          this.output_product_item(packaged_data);
        }
      }
    }
  }

  // Create an array of the real/fetched product data JSON
  fetch_url_based_json(arr, packaged_data){

    

    this.queried_collections.push(packaged_data.breadcrumb_parent_handle);
    for(var i = 0; i < arr.length; i++) {
      fetch(arr[i]) // replace with the actual URL
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        packaged_data.collection_products = packaged_data.collection_products.concat(data.products);
        packaged_data.parsed_urls++;
        if(packaged_data.parsed_urls == arr.length) {
          this.init(packaged_data);
        }
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        this.swatch_fetch_failed();
      });
    }
  }

  // Initialisation
  init(packaged_data){
   
    if(this.render_type === 'product-item') {
      this.collection_data_fulfilled = this.collection_data_fulfilled + 1;
    }
  
    // Loop collection products and compare to metafield JSON
    for(var i = 0; i < packaged_data.collection_products.length; i++) {
      var related_fabric = "";
      var valid = false;
      var current_product_active = false;
      var tooltip_img = packaged_data.collection_products[i].images[0].src.replaceAll(".jpg", this.tooltip_img_size);
      var fabric_img = packaged_data.collection_products[i].images[0].src.replaceAll(".jpg", this.fabric_img_size);
      var product_item_preview_img = packaged_data.collection_products[i].images[0].src.replaceAll(".jpg", this.product_item_preview_img_size);
      var product_item_preview_img_secondary = "";
      if(packaged_data.collection_products[i].images.length > 1){
        product_item_preview_img_secondary = packaged_data.collection_products[i].images[1].src.replaceAll(".jpg", this.product_item_preview_img_size);
      }

      // Find the correlating swatch item from the JSON which matches the collection-products gathered item in the for loop
      var related_swatch_item = false;
      for(var ix = 0; ix < packaged_data.fabric_json.products.length; ix++) {
        if(packaged_data.fabric_json.products[ix]._handle == packaged_data.collection_products[i].handle) {
          related_swatch_item = packaged_data.fabric_json.products[ix];
        }
      }
      // If a correlating swatch item has been found, define the variables which will then make up the structure of the swatch item in the final JSON output
      if(related_swatch_item) {
        valid = true;
        related_fabric = related_swatch_item._fabric;
        if(related_swatch_item._imgAsset) {
          fabric_img = related_swatch_item._imgAsset;
        }
        if(packaged_data.collection_products[i].handle == this.current_product_handle) {
          current_product_active = true;
        }
      }
      else {
        console.warn("Missing from Swatch JSON: " + packaged_data.collection_products[i].handle);
        if(document.querySelector(`.product-item__ .product-item-swatch-caller[data-product-item-handle='${packaged_data.collection_products[i].handle}']`)){
          const li = document.querySelector(`.product-item__ .product-item-swatch-caller[data-product-item-handle='${packaged_data.collection_products[i].handle}']`).closest(".product-item__");
          this.yoink(li, "Init()", "Missing from Swatch JSON / Related swatch object not found");
        }
      }
      // Push the swatch data object to the final JSON output
      if(valid) {
        this.final_output_json[packaged_data.breadcrumb_parent_handle].swatches.push({
          "handle": packaged_data.collection_products[i].handle,
          "active": current_product_active,
          "img_tooltip": tooltip_img,
          "img_fabric": fabric_img,
          "img_product_item_preview_img": product_item_preview_img,
          "img_product_item_preview_img_secondary": product_item_preview_img_secondary,
          "fabric": related_fabric,
          "group": related_swatch_item._group,
          "product_title": packaged_data.collection_products[i].title,
          "price": packaged_data.collection_products[i].variants[0].price,
          "compare_at_price": packaged_data.collection_products[i].variants[0].compare_at_price
        });
        // Add the unique fabric to the list
        if(!this.final_output_json[packaged_data.breadcrumb_parent_handle].fabrics.includes(related_fabric)) {
          this.final_output_json[packaged_data.breadcrumb_parent_handle].fabrics.push(related_fabric);
        }
      }
      else {
        console.error("Swatch Data Invalid: 1")
      }
    }

    if(packaged_data.associated_by === "null") {
      this.final_output_json[packaged_data.breadcrumb_parent_handle].associated_by = "null";
    }
    else {
      this.final_output_json[packaged_data.breadcrumb_parent_handle].associated_by = packaged_data.associated_by;
    }

    // Once all collection data is fullfilled, then proceed to populate
    if(packaged_data.render_type === 'product-main') {
      this.output_product_main(packaged_data);
    }
    else if (packaged_data.render_type === 'product-item' && this.collection_data_fulfilled === this.collection_data_expected) {
      this.output_product_item(packaged_data);
    }
  }

  remove_placeholder_elements(container){
    container.querySelectorAll(".fabric_placeholder").forEach(placeholder => placeholder.remove());
    container.querySelectorAll(".swatch_placeholder").forEach(placeholder => placeholder.remove());
  }




  // Output ~ Product Main
  output_product_main(packaged_data){
    try {
      // Prepare the replacement HTML
      var new_html = ""
      var swatches_html = "";
      const this__product_handle = document.querySelector(".product-main-swatch-caller").getAttribute("data-product-handle");
      const this__breadcrumb_parent_handle = document.querySelector(".product-main-swatch-caller").getAttribute("data-breadcrumb-parent-handle_w_underscores");

      // Remove appropriate swatches from the output JSON (ie if filtered by fabric or by groups)
      var output_JSON = this.final_output_json[this__breadcrumb_parent_handle];
      output_JSON = this.filter_JSON(output_JSON, this__product_handle, {
        "filter_by_fabric": false,
        "filter_by_group": true
      }, packaged_data);

      // Populate the replacement HTML
      for(var i = 0; i < output_JSON.swatches.length; i++) {
        var active_ = "";
        if(output_JSON.swatches[i].active) {
          active_ = " current";
        }
        var fabric_title = output_JSON.swatches[i].product_title;
        if(fabric_title.includes("- ")) {
          fabric_title = fabric_title.split("- ")[1];
        }
        new_html = `
        <a href="/products/${output_JSON.swatches[i].handle}" class="product-colour-swatch ${active_}" data-fabric="${output_JSON.swatches[i].fabric}" data-current-price="${output_JSON.swatches[i].price}" style="display: none;">
          <div class="tooltip">
            <img src="${output_JSON.swatches[i].img_tooltip}" alt="${output_JSON.swatches[i].product_title} tooltip image" loading="lazy">
            <span>${fabric_title}</span>
          </div>
          <img src="${output_JSON.swatches[i].img_fabric}" class="fabric_img">
        </a>`;
        swatches_html += new_html;
      }

      // Inject the replacement HTML
      packaged_data.swatch_colours_container.innerHTML += swatches_html;

      // Post Populated Checks & Display
      if(!(output_JSON.fabrics[0] == '' || output_JSON.fabrics.length < 1)) {
        // Ensure there are multiple fabrics
        if(this.elaborate_fabric_labels && fabric_metaobject_arr) {
          // this.fabric_metaobject
          var html_ = "";
          output_JSON.fabrics.forEach(fbric => {

            // var fabric_handle__ = fbric.replaceAll(" ", "_").replaceAll("%", "_").replaceAll("'", "").replaceAll("™", "").toLowerCase();
            var fabric_handle__ = handleize_w_underscore(fbric);

            if(fabric_metaobject_arr[fabric_handle__]) {

              var json_item = fabric_metaobject_arr[fabric_handle__];

              var benefits_list = "";
              if(json_item.benefits_list) {
                if(json_item.benefits_list.includes("|")){
                  json_item.benefits_list.split("|").forEach(benefit => {
                    if(benefit.length > 1) benefits_list += `<li>${benefit}</li>`;
                  });
                  benefits_list = "<ul class='benefits_list'>" + benefits_list + "</ul>";
                }
                else {
                  benefits_list = "<ul class='benefits_list'><li>" + json_item.benefits_list + "</ul>";
                }
              }

              html_ += `
              <div class="fabric_parent fabric_parent_${handleize_w_underscore(fbric)} elaborate_fabric swiper-slide" data-fabric-container="${fbric}" data-fabric-groupings="${json_item.grouping}">
                <div class="top_info">
                  <img src="${json_item.fabric_thumbnail_image.replace("1x1", "150x150")}" width="150" height="150">
                  <h4 class="elaborate_fabric_title">${json_item.fabric_title}</h4>
                </div>
                <div class="lower_info">
                  ${benefits_list}
                </div>
              </div>
              `;

            }

            else { 
              console.error("Missing reference in fabric metaobject: " + fabric_handle__);
              html_ += `
              <div class="fabric_parent fabric_parent_${handleize_w_underscore(fbric)} elaborate_fabric swiper-slide" data-fabric-container="${fbric}">
                <div class="top_info">
                  <img src="" width="700" height="700" class="unprocessed_img" style="opacity: 0;">
                  <h4 class="elaborate_fabric_title">${fbric}</h4>
                </div>
              </div>
              `;
            }
          });


          const elaborate_fabric_container_node = document.createElement("div");
          elaborate_fabric_container_node.classList = "swiper";
          elaborate_fabric_container_node.id = "elaborate_fabric_container";
          elaborate_fabric_container_node.innerHTML = `<div id="elaborate_fabric_container" class="swiper"><div class="swiper-wrapper">` + html_ + `</div></div>`;

          packaged_data.swatch_fabrics_container.innerHTML = "";
          packaged_data.swatch_fabrics_container.appendChild(elaborate_fabric_container_node);

        }
        else {
          for(var i = 0; i < output_JSON.fabrics.length; i++) {
            packaged_data.swatch_fabrics_container.innerHTML = `<span class="fabric_parent fabric_parent_${output_JSON.fabrics[i]}" data-fabric-container="${output_JSON.fabrics[i]}">${output_JSON.fabrics[i]}</span>` + packaged_data.swatch_fabrics_container.innerHTML;
          }
        }

        const active_fabric = packaged_data.swatch_colours_container.querySelector(".current").getAttribute("data-fabric");
        packaged_data.swatch_fabrics_container.querySelector('[data-fabric-container="' + active_fabric +'"]').classList.add("selected");
        (packaged_data.swatch_fabrics_container.querySelector(".selected").parentElement).prepend(packaged_data.swatch_fabrics_container.querySelector(".selected"));



        try {
          // Organise Fabric By Groups
          const current_fabric_child_nodes = Array.from(packaged_data.swatch_fabrics_container.querySelectorAll(".fabric_parent"));
          const new_fabric_child_node_array = [];
          const all_fabric_groupings = [];

          const selected_fabric_attr = packaged_data.swatch_fabrics_container.querySelector(".fabric_parent.selected")?.hasAttribute("data-fabric-groupings");
          if(selected_fabric_attr){
            all_fabric_groupings.push(selected_fabric_attr);
          }
          // - Map the fabrics in a list
          for(var i = 0; i < current_fabric_child_nodes.length; i++) {
            if(current_fabric_child_nodes[i].hasAttribute("data-fabric-groupings") && !all_fabric_groupings.includes(current_fabric_child_nodes[i].getAttribute("data-fabric-groupings"))) {
              all_fabric_groupings.push(current_fabric_child_nodes[i].getAttribute("data-fabric-groupings"))
            }
          }
          // - Loop the fabrics list to make an array of the fabrics in correct order
          for(var i = 0; i < all_fabric_groupings.length; i++) {
            // - Find the node items related to X fabric
            for(var j = 0; j < current_fabric_child_nodes.length; j++) {
              if(current_fabric_child_nodes[j].hasAttribute("data-fabric-groupings")) {
                if(current_fabric_child_nodes[j].getAttribute("data-fabric-groupings") === all_fabric_groupings[i]) {
                  new_fabric_child_node_array.push(current_fabric_child_nodes[j]);
                }
              }
            }
          }
          // - Inject the new nodes in the correct order
          packaged_data.swatch_fabrics_container.querySelector(".swiper-wrapper").innerHTML = "";
          for(var i = 0; i < new_fabric_child_node_array.length; i++) {
            packaged_data.swatch_fabrics_container.querySelector(".swiper-wrapper").appendChild(new_fabric_child_node_array[i]);
          }
        }
        catch(err) {
          console.log(err);
        }


        // Display Fabric Price Differences
        if(this.elaborate_fabric_labels_show_price_diff) {
          try {
            if(this.elaborate_fabric_labels) {
              // - Populate Lowest Price Data To Each Fabric 
              const swatches_ = packaged_data.swatch_colours_container.children;
              for(var i = 0; i < swatches_.length; i++) {
                if(swatches_[i].hasAttribute("data-current-price")) {
                  const relevant_fabric = packaged_data.swatch_fabrics_container.querySelector(`.fabric_parent[data-fabric-container="${swatches_[i].getAttribute("data-fabric")}"]`);

                  if(relevant_fabric.hasAttribute("data-fabric-starting-from")){
                    const parsed_product_price = parseFloat(swatches_[i].getAttribute("data-current-price"));
                    const parsed_current_fabric_price = parseFloat(relevant_fabric.getAttribute("data-fabric-starting-from"));
                    if(parsed_current_fabric_price > parsed_product_price) {
                      relevant_fabric.setAttribute("data-fabric-starting-from", (swatches_[i].getAttribute("data-current-price")));
                    }
                  }
                  else {
                    relevant_fabric.setAttribute("data-fabric-starting-from", (swatches_[i].getAttribute("data-current-price")));
                  }
                }
              }
              // - Calculate The Difference To Current, And Add Price Difference UI To Each Fabric
              const fabrics_ = packaged_data.swatch_fabrics_container.querySelectorAll(".elaborate_fabric");
              const current_price = parseFloat(packaged_data.swatch_colours_container.querySelector(".product-colour-swatch.current").getAttribute("data-current-price"));
              for(var i = 0; i < fabrics_.length; i++) {
                if(current_price && fabrics_[i].hasAttribute("data-fabric-starting-from") && !(fabrics_[i].classList.contains("selected"))) {

                  const fabric_price = parseFloat(fabrics_[i].getAttribute("data-fabric-starting-from"));

                  var change = false;

                  if(current_price < fabric_price) {
                    change = document.createElement("span");
                    change.classList = "price_diff price_is_more";
                    const money = ((fabric_price - current_price).toFixed(2)).replace(".00", "");
                    change.innerHTML = `<span class="price_diff_pre_msg price_diff_upgrade_msg">Upgrade naar</span> ` + format_money_js(money, "string");
                  }
                  // else if(current_price > fabric_price) {
                  //   change = document.createElement("span");
                  //   change.classList = "price_diff price_is_less";
                  //   const money = ((current_price - fabric_price).toFixed(2)).replace(".00", "");
                  //   change.innerHTML = '<b>-</b> ' + format_money_js(money, "string");
                  // }
                  // else {
                  //   change = document.createElement("span");
                  //   change.classList = "price_diff price_is_equal";
                  //   change.innerHTML = format_money_js(0, "string");
                  // }

                  if(change){
                    fabrics_[i].querySelector(".elaborate_fabric_title").appendChild(change);
                  }
                }
              }
                
            }
          
          }
          catch(err){
            console.log(err)
          }
        }



        packaged_data.swatch_colours_container.querySelectorAll('[data-fabric="' + active_fabric +'"]').forEach(a => {
          a.style.display = "";
        });


        // Upon fabric change, automatically change page to cheapest fabric available
        if(this.elaborate_fabric_labels && this.elaborate_fabric_labels_change_page_on_click) {
          packaged_data.swatch_fabrics_container.querySelectorAll(".elaborate_fabric").forEach(fabric => {
            fabric.addEventListener("click", function(){
              if(!fabric.classList.contains("selected")) {
                const swatches_belonging_to_fabric = packaged_data.swatch_colours_container.querySelectorAll(`a[data-fabric="${fabric.getAttribute("data-fabric-container")}"]`);
                var cheapest_price = false;
                var cheapest_destination = swatches_belonging_to_fabric[0].href;
                for(var i = 0; i < swatches_belonging_to_fabric.length; i++){
                  if(swatches_belonging_to_fabric[i].hasAttribute("data-current-price")) {
                    const this_fabric_price = parseFloat(swatches_belonging_to_fabric[i].getAttribute("data-current-price"));
                    if(!cheapest_price || this_fabric_price < cheapest_price) {
                      cheapest_price = this_fabric_price;
                      cheapest_destination = swatches_belonging_to_fabric[i].href;
                    }
                  }
                }
                window.location.href = cheapest_destination;
              }
            });
          });
        }

      }
      else {
        packaged_data.swatch_colours_container.querySelectorAll('a').forEach(a => {
          a.style.display = "";
        });
        if(document.querySelector(".choose_a_fabric_label")) {
          document.querySelector(".choose_a_fabric_label").remove();
        }
      }

      this.remove_placeholder_elements(packaged_data.container);

      if(typeof(swatch_quick_fix_implement_groupings) !== "undefined") {
        swatch_quick_fix_implement_groupings();
      }
      if(typeof(fix_js_fabric_widths) !== "undefined") {
        fix_js_fabric_widths();
      }

      // Add Event Listeners
      this.product_main_functionality(packaged_data);

      if(this.product_main_ready_callback){
        this.product_main_ready_callback();
      }

    }
    catch(err) {
      this.swatch_fetch_failed(packaged_data, err, "Failed on Output product main")
    }
  }


  // Output ~ Product Item
  // -- Instead of calling this numerous times for subcollections with many product items, it will instead only fire on document ready or if manually called again via ajaxinate
  output_product_item(packaged_data){

    if(packaged_data.post_ajax_fetch == true){console.log(`%c Recieved ${packaged_data.breadcrumb_parent_handle} step 1`, "color:orange;");}

    var packaged_data = packaged_data;

    if((this.final_output_json.hasOwnProperty(packaged_data.breadcrumb_parent_handle))) {

      


      // Call the query_products method on the product-items. Use Bind to provide access to 'this'
      const boundQueryProducts = query_products.bind(this);
      if(document.readyState !== 'complete') {
        document.onreadystatechange = function () {
          boundQueryProducts();
        }
      }
      else {
        boundQueryProducts(); 
      }
    }
    else {
      
    }
    
    // Query the product-items and if not already populated, prepare them to begin injecting the new swatch data
    function query_products(){
      if(packaged_data.injected == false) {
        const li_items = document.querySelectorAll(".product-item__");
        for(var li = 0; li < li_items.length; li++) {
          // list_item_process(li_items[li]);
          const bound_list_item_process = this.list_item_process.bind(this);
          bound_list_item_process(li_items[li], packaged_data);
        }
      }
      else {
        const li_item = packaged_data.script_caller_node.closest(".product-item__");
        if(packaged_data.post_ajax_fetch == true && li_item.querySelector(".swatch_placeholder")){
          packaged_data.script_caller_node.classList.remove("processed");
        }
        const bound_list_item_process = this.list_item_process.bind(this);
        bound_list_item_process(li_item, packaged_data);
      }
    }
    this.master_check_product_items();
  }


  // Inject the content into the 'product-item' list items
  list_item_process(li_item, packaged_data) {

    // Reset variable failure variable
    packaged_data.failure = false;

    packaged_data.container = li_item.querySelector(".product-card-swatches");

    // Attatch event listeners to swatches, ie click and change image/title and price to new product/fabric
    li_item.addEventListener("click", this.product_item_functionality);

    if(li_item.querySelector(".product-item-swatch-caller")){

      if(!li_item.querySelector(".product-item-swatch-caller").classList.contains("processed") && !li_item.querySelector("a.product-colour-swatch")) {

        const this__product_handle = li_item.querySelector(".product-item-swatch-caller").getAttribute("data-product-item-handle");
        const this__breadcrumb_parent_handle = li_item.querySelector(".product-item-swatch-caller").getAttribute("data-breadcrumb-parent-handle_w_underscores");

        // Remove appropriate swatches from the output JSON (ie if filtered by fabric or by groups)
        var output_JSON = this.final_output_json[this__breadcrumb_parent_handle];
        output_JSON = this.filter_JSON(output_JSON, this__product_handle, {
          "filter_by_fabric": true,
          "filter_by_group": true
        }, packaged_data);

        // Add the swatch and any extra data needed for the click functionality to the product-item swatch container
        if(this__product_handle && this__breadcrumb_parent_handle && packaged_data.failure !== true) {
          for(var i = 0; i < output_JSON.swatches.length; i++) {
            var fabric_title = output_JSON.swatches[i].product_title;
            if(fabric_title.includes("- ")) {
              fabric_title = fabric_title.split("- ")[1];
            }
            
            const new_swatch = document.createElement("a");
            new_swatch.href = `/products/${output_JSON.swatches[i].handle}`;
            new_swatch.setAttribute("data-fabric", output_JSON.swatches[i].fabric);
            new_swatch.setAttribute("data-product_preview_img", output_JSON.swatches[i].img_product_item_preview_img);
            new_swatch.setAttribute("data-product_preview_img_secondary", output_JSON.swatches[i].img_product_item_preview_img_secondary);
            new_swatch.setAttribute("data-product-title", output_JSON.swatches[i].product_title);
            new_swatch.setAttribute("data-product-price", output_JSON.swatches[i].price);
            if(output_JSON.swatches[i].compare_at_price != null) {
              new_swatch.setAttribute("data-product-compare_at_price", output_JSON.swatches[i].compare_at_price);
            }
            if(output_JSON.swatches.length > 5 && i > 3) {
              new_swatch.style.display = "none";
            }
            const new_swatch_img = document.createElement("img");
            new_swatch_img.src = output_JSON.swatches[i].img_fabric;
            new_swatch_img.classList = "fabric_img";

            var active_ = "";
            if(output_JSON.swatches[i].handle == this__product_handle) {
              active_ = " active original_swatch";
            }
            new_swatch.classList = `product-colour-swatch ${active_}`;
            new_swatch.appendChild(new_swatch_img);
            packaged_data.container.appendChild(new_swatch);
          }

          if(output_JSON.swatches.length > 5) {
            packaged_data.container.classList.add("quantity_shown");
            packaged_data.container.classList.add("has_view_more");

            const view_more_node = document.createElement("button");
            view_more_node.classList = "view_more";
            view_more_node.setAttribute("title", "Toon meer");
            view_more_node.setAttribute("aria-label", "Toon meer Fabrics");
            view_more_node.setAttribute("data-has-loc-attr", "");
            view_more_node.addEventListener("click", function(){
              Array.from(this.parentElement.children).forEach(node => {
                if(node.nodeName === 'A') {
                  node.style.display = "";
                }
              });
              this.remove();
            });
            packaged_data.container.appendChild(view_more_node);
          }
          this.remove_placeholder_elements(packaged_data.container);
        }

        // Mark as processed so this doesn't get re-run again
        if(li_item.querySelector(".product-item-swatch-caller")){
          li_item.querySelector(".product-item-swatch-caller").classList.add("processed");
        }

      }
    }
  }


  master_check_product_items(){
    // This class is triggered whenever the product-item output has been updated, as a backup to ensure all correctly have data and none are missed
    if(this.master_check_throttle_allow) {

      

      // When not satisfied due to items being unpopulated, this function will then retrigger
      var satisfied = true;

      const product_items = document.querySelectorAll(".product-item__");
      const problematic_product_items = [];

      // Find which ones have no swatch data
      for(var i = 0; i < product_items.length; i++){
        if(!product_items[i].querySelector("a.product-colour-swatch") && product_items[i].querySelector(".product-item-swatch-caller")){
          problematic_product_items.push(product_items[i]);
          satisfied = false;
        }
      }

      for(var i = 0; i < problematic_product_items.length; i++) {
        try{
          if(problematic_product_items[i].querySelector(".product-item-swatch-caller")) {
            const breadcrumb_parent_handle = problematic_product_items[i].querySelector(".product-item-swatch-caller").getAttribute("data-breadcrumb-parent-handle_w_underscores");
            if(this.final_output_json.hasOwnProperty(breadcrumb_parent_handle)) {

              // Create a fake package to send back to the 'list_item_process()'
              const pseudo_packaged_data = {
                "container": problematic_product_items[i].querySelector(".product-card-swatches"),
                "breadcrumb_parent_handle": breadcrumb_parent_handle,
                "failure": false,
                "render_type": "product-item",
                "recieved_via_master_check": true
              }
              problematic_product_items[i].querySelector(".product-item-swatch-caller").classList.remove("processed");
              this.list_item_process(problematic_product_items[i], pseudo_packaged_data);
            }
          }
        }
        catch(err) {
          // console.log(err);
          this.yoink(problematic_product_items[i], "master_checker_product_items", err)
        }
      }
      
      if(satisfied === false) {
          this.master_check_throttle_allow = false;
          setTimeout(()=> {
            this.master_check_throttle_allow = true;
            this.master_check_product_items();
          }, 1000);
      }
      else {
        this.master_check_throttle_allow = true;
      }
    }
  }


  filter_JSON(JSON, product_handle, options, packaged_data) {
    // Method used to take all of the JSON swatch object and remove irrelevant ones
    /*
    options : {
      "filter_by_fabric": true,
      "filter_by_group": true
    }
    */
    var active;
    try {
      active = JSON.swatches.find(item => item.handle === product_handle);
      var new_JSON = {...JSON};

      if(options.filter_by_group === true){
        if(new_JSON.associated_by == 'group') {
          new_JSON.swatches = new_JSON.swatches.filter(swatch => swatch.group === active.group);
        }
      }

      if(options.filter_by_fabric === true) {
        new_JSON.swatches = new_JSON.swatches.filter(swatch => swatch.fabric === active.fabric);
      }

      // Remove Empty Fabrics
      var remaining_fabrics = [];
      for(var i=0; i<new_JSON.swatches.length; i++){
        if(!remaining_fabrics.includes(new_JSON.swatches[i].fabric)) {
          remaining_fabrics.push(new_JSON.swatches[i].fabric);
        }
      }
      new_JSON.fabrics = remaining_fabrics;

      return new_JSON;
    }
    catch(err) {
      packaged_data.failure = true;
      this.swatch_fetch_failed(packaged_data, err, "Failed on filter operation");
      
    }
  }

  
  swatch_fetch_failed(packaged_data, err, note) {
    
    try {
      if(packaged_data.render_type === "product-main") {
        global_swatches_base.container.style.display = "none";
      }
      else if(packaged_data.render_type === "product-item") {        
        packaged_data.container.style.display = "none";
        this.yoink(packaged_data.container.closest(".product-item__"), "filter_JSON > swatch_fetch_failed", err);
      }
    }
    catch(err) {
      console.log(err);
      console.log("Error at the swatch failure operation");
    }
  }

  // Event listener for the main product page swatch elements
  product_main_functionality(packaged_data){

    if(!this.elaborate_fabric_labels && !this.elaborate_fabric_labels_change_page_on_click) {
      packaged_data.swatch_fabrics_container.querySelectorAll(".fabric_parent").forEach(btn => {
        btn.addEventListener("click", fabric_btn_click);
      });
    }

    const swatch_colours_container = packaged_data.swatch_colours_container;
    const swatch_fabrics_container = packaged_data.swatch_fabrics_container;

    function fabric_btn_click(e) {
      if(this.getAttribute("data-fabric-container")){
        swatch_fabrics_container.querySelectorAll(`.fabric_parent`).forEach(fabric_parent => {
          fabric_parent.classList.remove("selected");
        });
        this.classList.add("selected");
        swatch_colours_container.querySelectorAll("a").forEach(a => {
          a.style.display = "none";
        });
        swatch_colours_container.querySelectorAll(`a[data-fabric="${this.getAttribute("data-fabric-container")}"]`).forEach(a => {
          a.style.display = "";
        });
      };
    }
  }

  // Event listener for the product-items swatch elements
  product_item_functionality(e) {
    const target = e.target;

    if(target.closest("a.product-colour-swatch") && target.closest(".product-item__") && target.closest(".product-item__").querySelector("img")) {

      e.preventDefault();
      e.stopPropagation();
      const swatch_clicked = e.target.closest(".product-colour-swatch");
      const product_item_ = e.target.closest(".product-item__");
      const figure_ = target.closest(".product-item__").querySelector(".product-card-figure");
      const img_ = figure_.querySelectorAll("img");

      // Standard things to do globally
      // -- Active swatch class
      if(swatch_clicked.closest(".product-card-swatches").querySelector(".active")) {
        swatch_clicked.closest(".product-card-swatches").querySelector(".active").classList.remove("active");
      }
      swatch_clicked.classList.add("active");
      // -- Update Links
      product_item_.querySelector(".product-card-figure a").href = swatch_clicked.href;
      product_item_.querySelector(".product-card-details .title a").href = swatch_clicked.href;

      // -- Update Title & Subtitle
      var title = swatch_clicked.getAttribute("data-product-title");
      if(title.includes("- ")) {
        title = title.split("- ");
        title = title[0] += `<span class="sub-title">${title[1]}</span>`;
      }
      product_item_.querySelector(".product-card-details .title a").innerHTML = title;

      // -- Update Prices
      product_item_.querySelector(".money-current").innerText = format_money_js(swatch_clicked.getAttribute("data-product-price"), "string");
      if(swatch_clicked.getAttribute("data-product-compare_at_price")) {
        if(!product_item_.querySelector(".original.money")) {
          const compare_at_node = document.createElement("span");
          compare_at_node.classList = "original money";
          product_item_.querySelector(".product-item__price").prepend(compare_at_node);
        }
        product_item_.querySelector(".original.money").innerText = format_money_js(swatch_clicked.getAttribute("data-product-compare_at_price"), "string");
      }
      else if(product_item_.querySelector(".original.money")) {
        product_item_.querySelector(".original.money").remove();
      }

      // -- Remove badges if exist
      if(product_item_.querySelector(".product_item_price_badge")) {
        product_item_.querySelector(".product_item_price_badge").remove();
      }
      
      img_[0].classList.add('pre');
      setTimeout(()=>{
        img_[0].classList.remove('pre');
      }, 400);
      img_[0].classList.add('loading');
      img_[0].setAttribute("onload", "this.classList.remove('loading')");


        if(!img_[0].hasAttribute("data-original-image-src")) {
          img_[0].setAttribute("data-original-image-src", img_[0].src);

          if(img_.length > 1) img_[1].setAttribute("data-original-image-src", img_[1].src);

        }
        // Remove Source nodes
        if(figure_.querySelector("source")) {
          for(var i = (figure_.querySelectorAll("source").length - 1); i >= 0; i-- ) {
            figure_.querySelectorAll("source")[i].remove();
          }
        }

        img_[0].src = swatch_clicked.getAttribute("data-product_preview_img");
        if(img_.length > 1) img_[1].src = swatch_clicked.getAttribute("data-product_preview_img_secondary");
        
      //}
    }

  }

  // A method used to remove any error related swatch data from the page, and instead just display the standard product-item without any swatch container
  yoink(product_item, yoink_location, err) {
    
    try {
      const swatch_container = product_item.querySelector(".product-card-swatches");
      if(swatch_container.querySelector(".product-item-swatch-caller")) {
        swatch_container.querySelector(".product-item-swatch-caller").remove();
      }
      swatch_container.remove();
      this.yoinked_items.push({
        "product_item": product_item,
        "yoink_location": yoink_location,
        "Error": err
      })
    }
    catch(err) {
      
    }

  }

}


class async_page_renderer {
  /* Parameter is an options object:
  {
    this.trigger_nodes = {DOM Nodes Array} The nodes that will triggg
    this.root_node_ids = options.root_nodes,
    cherry_pick: {Boolean} If true, this will query all the individual target child nodes and replace or hide each one, one by one. If false, this will inject all content from the new root into the old root

    callback__initial_click: {Functions} Callback functions which can be called when the user immediatley clicks a trigger (before a fetch has begun)
    callback__fetch_success: {Functions} Callback functions which can be called when a fetch request is succesful
    callback__page_update: {Functions} Callback functions which can be called when a populate page updates
  }



  Class Overview:
  |
  |- apply_event_listeners() ~ Applys event listeners to <a> nodes which will cause triggers
       |
       |- trigger_prefetch() ~ Applys logic to <a> node that it will prefetch the nodes URL
          |____
              |- check_data_is_stored(url, populate_if_true(false)) ~ Downloads and stores the fetch URL data
       |
       |
       |- trigger_start() ~ Applys logic to <a> node that it will trigger from a click based on the nodes URL
          |____
              |- check_data_is_stored(url, populate_if_true(true)) ~ Checks data is available, if not perform_fetch(url, true)
              |____
                  |- populate_page(html) ~ Gets the available HTML


  */
  constructor(options){
    this.trigger_nodes = Array.isArray(options.trigger_nodes) ? options.trigger_nodes : [],
    this.prefetch_nodes = Array.isArray(options.prefetch_nodes) ? options.prefetch_nodes : [],
    this.root_nodes = Array.isArray(options.root_nodes) ? options.root_nodes : [],
    this.cherry_pick = options.cherry_pick,
    this.DomParser = new DOMParser,

    this.callback__initial_click = options.callback__initial_click,
    this.callback__fetch_success = options.callback__fetch_success,
    this.callback__page_update = options.callback__page_update,

    this.stored_data = [],
    this.fetch_queue = [];
    this.failed_requests = [];

    this.debug_mode = true;
    // this.debug_mode();

    if((options.trigger_nodes?.length > 0) && (this.root_nodes.length > 0)) {
      this.apply_event_listeners();
    }
    else {
      console.warn("No trigger nodes for Async Page Renderer");
    }



  }

  apply_event_listeners(){
    if(this.trigger_nodes.length > 0) {
      this.trigger_nodes.forEach(node => {
        node.addEventListener("click", (e) => {
          this.trigger_start(e);
        });
      });
    }
    if(this.prefetch_nodes.length > 0) {
      this.prefetch_nodes.forEach(node => {
        node.addEventListener("mouseover", (e) => {
          this.trigger_prefetch(e);
        });
        node.setAttribute("data-async-prefetch-ready", "");
      });
    }
  }

  trigger_prefetch(e){
    const node = e.currentTarget;
    if(node.hasAttribute("href") && node.hasAttribute("data-async-prefetch-ready")){
      node.removeAttribute("data-async-prefetch-ready");
      const url = this.utility__clean_url(e.currentTarget.href);
      console.log("clean_url");
      console.log(url);
      this.check_data_is_stored(url, false);
    }
  }
  
  trigger_start(e) {

    // CALLBACK ~ Initial Click
    if(typeof(this.callback__initial_click) === 'function'){ this.product_main_ready_callback(e); }

    e.preventDefault();
    e.stopPropagation();

    if(e.currentTarget.hasAttribute("href")){
      const url = this.utility__clean_url(e.currentTarget.href);
      console.log("clean_url");
      console.log(url);
      this.check_data_is_stored(url, true);
    }
    
    this.set_anim_class("leaving");
    
  }


  // Checks if we have the data stored already, or it is in the process of being fetched
  check_data_is_stored(url, populate_if_true) {

    console.log(this.stored_data);

    if(this.stored_data.find(item => item.url === url)) {
      // Use the already fetched HTML to begin populating the page
      if(populate_if_true) {
        this.populate_page(this.stored_data.find(item => item.url === url));
      }
      console.log("check_data_is_stored STATE = ALREADY POPULATED");

    }
    else if (this.fetch_queue.find(item => item.url === url)) {
      if(populate_if_true) {
        // Reset all other items in queue to not reset page
        this.fetch_queue.forEach(item => {
          console.log(item);
          item.update_page = false;
        });
        // Update the relevant item which is already in the queue, so once it is fulfilled then it will switch the page
        this.fetch_queue.find(item => item.url === url).update_page = true;
      }
      console.log("check_data_is_stored STATE = FETCHING");

    }
    else {
      // Run a fetch, and once complete populate the page
      this.perform_fetch(url, populate_if_true);
      console.log("check_data_is_stored STATE = NOT POPULATED");

    }
  }
  

  // The code to go and fetch the URL and store it, with the option of populating the page on success
  async perform_fetch(url, call_populate_page_on_success){

    const fetch_queue_item = {
      "url": url,
      "update_page": call_populate_page_on_success
    }
    this.fetch_queue.push(fetch_queue_item);

    const fetch_queue_item_index = this.fetch_queue.findIndex(item => item.url === url);

    // Perform HTML fetch request
    fetch(url)
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      return res.text();
    })
    .then(res => {
      // Add data to stored URLs
      const successobj = {
        "url": url,
        "html": res
      }
      this.stored_data.push(successobj);

      // Final result stored, we will pass into the parameter at the end to determine whether to populate the page
      let update_page = fetch_queue_item.update_page;

      // Remove URL from fetch queue
      let fetch_queue_item_index = this.fetch_queue.findIndex(item => item.url === url);
      if (fetch_queue_item_index > -1) {
        this.fetch_queue.splice(fetch_queue_item_index, 1);
      }
      else {
        console.log("this.fetch_queue");console.log(this.fetch_queue);console.log("url");console.log(url);
        throw new Error(`Can't find URL in fetch queue:`);
      }


      // CALLBACK ~ Fetch Success
      if(typeof(this.callback__fetch_success) === 'function'){ this.callback__fetch_success(); }


      if(update_page){
        this.populate_page(successobj)
      }
      
      return successobj;
      

    })
    .catch(error => {

      // Remove URL from fetch queue
      if (fetch_queue_item_index > -1) {
        this.fetch_queue.splice(fetch_queue_item_index, 1);
      }
      // Add URL info object to failed requests
      const err_object = {
        "url": url,
        "error": error
      }
      this.failed_requests.push(err_object);
      console.error('Fetch error:', error);
      console.log("Failed, now switching to " + url);
      console.log(error);
      //window.location.href = url;
    });


  }

  
  // Uses the provided HTML to begin populating the page
  populate_page(data_obj){

    try {

      const replace_html = (root_node_id) => {
        const new_html = this.DomParser.parseFromString(data_obj.html, "text/html");
        const old_root = document.getElementById(root_node_id);
        const new_root = new_html.getElementById(root_node_id);

        const old_document_full = document;
        const new_document_full = new_html;

        this.set_anim_class("entering");

        if(!old_root || !new_root) {
          throw new Error(`Can't find URL in fetch queue:`);
        }

        this.insert_dynamic_data('Essentials', null, null, null, old_document_full, new_document_full);

        // [data-dynamic-repopulate]
        if(old_root.querySelector("[data-dynamic-repopulate]") && new_root.querySelector("[data-dynamic-repopulate]")){
          this.insert_dynamic_data('data-dynamic-repopulate', old_root, new_root);
        }
        else {
          if(old_root.querySelector("[data-dynamic-repopulate]")) {
            throw new Error(`New HTML has no [data-dynamic-repopulate]`);
          }
          else {
            throw new Error(`Old HTML has no [data-dynamic-repopulate]`);
          }
        }

        // [data-dynamic-product-form]
        if(old_root.querySelector("[data-dynamic-product-form]")){
          if(new_root.querySelector("[data-dynamic-product-form]") && new_root.querySelector("#core_variants_array")){
            if(typeof(Main_Product) === 'object'){
              this.insert_dynamic_data('data-dynamic-product-form', old_root, new_root, data_obj.url);
            }
            else {
              throw new Error(`Can't find class 'Main_Product' to update from 'async_page_renderer'`);            
            }
          }
          else {
            throw new Error(`Missing critical items on new HTML`);
          }
        }


        // Update page state in browser
        if (data_obj.url) {
          var new_page_url = data_obj.url;
          new_page_url = new_page_url.replace("&CLEANHTMLCONTENT=1", "");
          new_page_url = new_page_url.replace("?CLEANHTMLCONTENT=1", "");

          var currentParams = new URLSearchParams(window.location.search);
          var urlObj = new URL(new_page_url, window.location.origin);
          currentParams.forEach((value, key) => {
            if (!urlObj.searchParams.has(key)) {
              urlObj.searchParams.append(key, value);
            }
          });
          new_page_url = urlObj.pathname + urlObj.search + urlObj.hash;
        
          window.history.replaceState({ asyncRendered: true, url: new_page_url }, "", new_page_url);
            
        }

        // [data-dynamic-script]
        if(old_root.querySelector("[data-dynamic-script]")){
          old_root.querySelectorAll("[data-dynamic-script]").forEach(script => {
            script_re_run(script);
          });
        }        

      }

      this.root_nodes.forEach(node => {
        const node_id = node.id;
        replace_html(node_id)
      });

      // CALLBACK ~ Page Update
      if(typeof(this.callback__page_update) === 'function'){ this.callback__page_update(); }

    }
    catch(error) {
      console.error(error);
      if(data_obj.url) {
        if(this.debug_mode) {
          debugger;
        }
        var fallback_url = data_obj.url;
        fallback_url = fallback_url.replace("&CLEANHTMLCONTENT=1", "");
        fallback_url = fallback_url.replace("?CLEANHTMLCONTENT=1", "");

        window.location.href = fallback_url;
      }
    }

  }



  insert_dynamic_data(method, old_root, new_root, fallback_url, old_document, new_document){

    console.log("-----------------------------------------");
    console.log(`method`);
    console.log(method);
    console.log(`old_root`);
    console.log(old_root);
    console.log(`new_root`);
    console.log(new_root);

    switch (method) {

      case 'Essentials' :

        const essential_items_specific_replace = [];
        essential_items_specific_replace.push(`link[rel="canonical"]`);
        essential_items_specific_replace.push(`meta[name="description"]`);
        essential_items_specific_replace.push(`title`);
        essential_items_specific_replace.push(`script[type="application/json"][data-section-type="static-product"]`);

        essential_items_specific_replace.push(`script[type="application/json"][data-section-type="static-product"]`);

        for(const e_item of essential_items_specific_replace) {
          const node_old = old_document.querySelector(e_item);
          const node_new = new_document.querySelector(e_item);
          if(node_old && node_new) {
            node_old.parentElement.replaceChild(node_new, node_old);
          }
        }


        // Structured Data
        document.querySelectorAll('head script[type="application/ld+json"]').forEach(el => el.remove());
        new_document.querySelectorAll('head script[type="application/ld+json"]').forEach(script => {
          const newScript = document.createElement("script");
          newScript.type = "application/ld+json";
          newScript.textContent = script.textContent;
          document.head.appendChild(newScript);
          console.log(newScript);
        });

        document.querySelectorAll('body script[type="application/ld+json"]').forEach(el => el.remove());
        new_document.querySelectorAll('body script[type="application/ld+json"]').forEach(script => {
          const newScript = document.createElement("script");
          newScript.type = "application/ld+json";
          newScript.textContent = script.textContent;
          document.body.appendChild(newScript);
          console.log(newScript);
        });



      break;

      case 'data-dynamic-repopulate':

        const old_items = Array.from(old_root.querySelectorAll("[data-dynamic-repopulate]"));
        const new_items = Array.from(new_root.querySelectorAll("[data-dynamic-repopulate]"));

        old_items.forEach(old_div => {
          const attribute_id = old_div.getAttribute("data-dynamic-repopulate");
          if(attribute_id == "") {
            console.warn("Data-Dynamic-Repopulate is missing an ID");
          }
          const found_item = new_items.find(item => item.getAttribute("data-dynamic-repopulate") === attribute_id);
          if(found_item) {
            old_div.innerHTML = found_item.innerHTML;
            found_item.hasAttribute("data-dynamic-blank") ? old_div.setAttribute("data-dynamic-blank", "") : old_div.removeAttribute("data-dynamic-blank");
          }
          else {
            if(this.debug_mode == true){
              console.log(`old_div`);
              console.log(old_div);
              console.log(`new_root`);
              console.log(new_root);
            }
            console.log(`Can't find 'data-dynamic-repopulate' = ${attribute_id}  in new HTML`);
          }
        });


        break;

      case 'data-dynamic-script':


        break;


      case 'data-dynamic-product-form':

        try {

          const old_form = old_root.querySelector("[data-dynamic-product-form]").querySelector(".product_page-form-inner");
          const new_form = new_root.querySelector("[data-dynamic-product-form]").querySelector(".product_page-form-inner");

          // Remove old form elements
          for(var ii = old_form.children.length - 1; ii >= 0; ii--) {
            if(old_form.children[ii].classList.contains("shopify_essential_product_select_form")) {
              for(var ll = old_form.children[ii].children.length - 1; ll >= 0; ll--) {
                old_form.children[ii].children[ll].remove();
              }
            }
            else if(old_form.children[ii].classList.contains("product_variation_option")) {
              old_form.children[ii].remove();
            }
          }

          // Inject new select options
          const select_box = old_form.querySelector("select.shopify_essential_product_select_form");
          const new_select_box_options = Array.from(new_form.querySelectorAll("select.shopify_essential_product_select_form option"));

          for(var ii = new_select_box_options.length - 1; ii >= 0; ii--) {
            select_box.appendChild(new_select_box_options[ii]);
          }


          // Inject new variant options UI
          const new_form_options = Array.from(new_form.querySelectorAll(".product_variation_option"));
          for (const option of [...new_form_options]) {
            select_box.parentElement.insertBefore(option, select_box);
          }


          // Update Product Variants JSON
          const old_variant_JSON = old_root.querySelector("#core_variants_array");
          const new_variant_JSON = new_root.querySelector("#core_variants_array");
          old_variant_JSON.innerHTML = new_variant_JSON.innerHTML;


          Main_Product.session_update("full_page_update", fallback_url);

        }
        catch(err) {
          console.log(err);
          throw new Error("Error occured processing 'data-dynamic-product-form'");
        }

        
        break;
      
    }
  }


  set_anim_class(state) {
    this.root_nodes.forEach(root_node => {
      switch (state) {
        case "leaving":
          root_node.classList.add("async_leaving");
          root_node.classList.remove("async_pre_enter");
          root_node.classList.remove("async_entering");
          break;
        case "entering":
          root_node.classList.add("async_pre_enter");
          root_node.classList.remove("async_leaving");
          root_node.classList.remove("async_entering");
          setTimeout(()=> {
            root_node.classList.add("async_entering");
          }, 300);
          setTimeout(()=>{
          root_node.classList.remove("async_pre_enter");
          root_node.classList.remove("async_entering");
          root_node.classList.remove("async_leaving");
          }, 600)
          break;
      }
    });
  }

  
  utility__clean_url(url) {
    var return_url = url;
    if(url.includes("?")) {
      return_url += '&CLEANHTMLCONTENT=1';
    }
    else {
      return_url += '?CLEANHTMLCONTENT=1';
    }
    return return_url;
  }


  debug_mode(){

    setTimeout(()=>{
      const debug_container = document.createElement("div");
      debug_container.style.position = "fixed";
      debug_container.style.top = "20px";
      debug_container.style.left = "20px";
      debug_container.style.width = "920px";
      debug_container.style.height = "440px";
      debug_container.style.background = "#031224f2";
      debug_container.style.zIndex = "9999";
      debug_container.style.color = "#fff";
      debug_container.style.padding = "16px 18px";
      debug_container.style.fontSize = "12px";
      debug_container.style.display = "flex";
      document.body.appendChild(debug_container);


      setInterval(()=> {
        var HTML = "";
        var html_stored_data = `<div style="width: 33%;"><h3 style="color: green;">Stored Data</h3>`;
        var html_fetch_queue = `<div style="width: 33%;"><h3 style="color: purple;">Fetch Queue</h3>`;
        var html_failed_requests = `<div style="width: 33%;"><h3 style="color: red;">Failed List</h3>`;

        this.stored_data.forEach(obj => {
          html_stored_data += `
            <div class="db_01" style="background-color: #1a1a1a;padding: 6px 10px;border-radius: 8px; ">
              <h6 style="font-size: 9px;">${obj.url}</h6>
              <div style="font-size: 5px;line-height: 6px;width: 100%;height: 27px;overflow: hidden;position: relative;">${(obj.html).toString()}</div>
            </div>         
          `;
        });
        html_stored_data += "</div>";

        this.fetch_queue.forEach(obj => {
          html_fetch_queue += `
            <div class="db_02" style="background-color: #1a1a1a;padding: 6px 10px;border-radius: 8px; ">
              <h6 style="font-size: 9px;">${obj.url}</h6>
              <div style="font-size: 24px;line-height: 6px;width: 100%;height: 27px;overflow: hidden;position: relative; color: orange;">${obj.update_page}</div>
            </div>
          `;
        });
        html_fetch_queue += "</div>";

        this.failed_requests.forEach(obj => {
          html_failed_requests += `
            <div class="db_03" style="background-color: #1a1a1a;padding: 6px 10px;border-radius: 8px; ">
              <h6 style="font-size: 9px;">${obj.url}</h6>
              <div style="font-size: 10px;line-height: 6px;width: 100%;height: 27px;overflow: hidden;position: relative; color: red;">${obj.error}</div>
            </div>`;
        });
        html_failed_requests += "</div>";

        HTML = html_stored_data + html_fetch_queue + html_failed_requests;

        debug_container.innerHTML = HTML;

      }, 200);


    }, 500);
  }
  
}

function ugc_output(data_array, options){

  
  
  
  
  // "columns_size_config": Array of media queries. Each media query is a tuple of integers: ("max screen width"(omit on first as this is largest screen), "column count" , "minimum number of items for pinterest style layout"  )

  try {

    if(options.columns_size_config?.length > 0) {

      var refined_array = [];
      var max_window_size = 99999;
      var threshold_hit = false;
      var columns = null;
      var pinterest_style_valid = false;
      var hide_by_default = "";
      if(options.show_swiper_arrows == true) {
        this.arrows_buttons = true;
      }
      if(options.hideByDefault == true) {
        hide_by_default = ' style="display: none"';
      }
      var lazy_load_video = false;
      if(options.lazy_load_video_attribute == true) {
        lazy_load_video = true
      }
      function make_refined_array(){ 
        data_array.forEach( item => {
          const obj = {};
          obj.item = {...item};
          if(item.aspect_ratio === 'square') {
            obj.AR = 150;
          }
          else if(item.aspect_ratio === 'landscape') {
            obj.AR = 100;
          }
          else if(item.aspect_ratio === 'portrait') {
            obj.AR = 210;
          }
          else {
            console.log("Cant find aspect ratio for: " + item.url);
          }
          refined_array.push(obj);
        });
      }

      function sort_array() {
        // Sort Method
        if(options.sortMethod == "random"){
          refined_array = shuffle(refined_array);
        }
        else if(options.sortMethod == "rating") {
          refined_array = refined_array.sort((a, b) => b.item.num - a.item.num);
        }

        // Limit Method
        refined_array = refined_array.slice(0, options.limit);
      }

      function check_valid(){ 
        for(var i = 0; i < options.columns_size_config.length; i++){
          if(i === 0) {
            if(options.columns_size_config[i][0] > 20) {
              throw new Error("'columns_size_config' is incorrect... the first value should be a single item array of the columns, not page width");
            }
            columns = options.columns_size_config[i][1];
            if(refined_array.length >= options.columns_size_config[i][2]) {
              threshold_hit = true;
            }
          }
          else {
            if(window.innerWidth < options.columns_size_config[i][0] && options.columns_size_config[i][0] < max_window_size) {
              columns = options.columns_size_config[i][1];
              if(refined_array.length >= options.columns_size_config[i][2]) {
              threshold_hit = true; 
              }
            }
          }
        }
        if(refined_array.length > 0 && columns && threshold_hit) {
          pinterest_style_valid = true;
        }
        if(options.pinterest_mode === true) {
          pinterest_style_valid = true;
        }
      }

      // Pinterest Style Gallery
      function ugc_gallery_design(array, column_count, container) {

        function splitIntoColumns(items, numColumns) {

            const columns = Array.from({ length: numColumns }, () => []);
            const columnSums = Array(numColumns).fill(0);

            // Sort items by AR descending
            const sortedItems = shuffle([...items]);

            for (const item of sortedItems) {
                // Find the column with the smallest current AR sum
                let minIndex = columnSums.indexOf(Math.min(...columnSums));

                columns[minIndex].push(item);
                columnSums[minIndex] += item.AR;
            }

            return columns;
        }


        function staggerColumns(cols) {
            // Get total heights per column
            const colData = cols.map((col, idx) => ({
                col,
                sum: col.reduce((a, b) => a + b.AR, 0)
            }));

            // Sort ascending by height
            colData.sort((a, b) => a.sum - b.sum);

            const result = [];
            let left = 0;
            let right = colData.length - 1;

            // Alternate smallest, largest, smallest, largest...
            while (left <= right) {
                if (left <= right) result.push(colData[left++].col);
                if (left <= right) result.push(colData[right--].col);
            }

            return result;
        }

          
        const columns = splitIntoColumns(array, column_count);

        
        const output_columns = staggerColumns(columns);

        return output_columns;

      }

      // Mobile Style Gallery
      function ugc_fallback_gallery_swiper(items, container){
        let swiper_items = items;
        container.classList.add("fallback_gallery");
        const node = document.createElement("div");
        node.classList = "ugc_swiper swiper";
        let html = '<div class="swiper-wrapper fake_max_width_left_side">';
        swiper_items.forEach(input_obj => {

          let media_url = input_obj.item.url;
          

          if(input_obj.item.type ==="img"){
            html += `
            <div class="swiper-slide aspect_ratio_${input_obj.item.aspect_ratio}">
              <div href="${media_url}" class="UGC_Item UGC_Item_Img swiper_item">
                <img src="${media_url}" loading="lazy">
              </div>
            </div>`;
          }
          else if(input_obj.item.type ==="video"){
            let src_val = `src="${media_url}"`
            if(lazy_load_video == true){
              src_val = `src="" lazy_video_src="${media_url}"`;
            }
            html += `
            <div class="swiper-slide aspect_ratio_${input_obj.item.aspect_ratio}">
              <div href="${media_url}" class="UGC_Item UGC_Item_Video swiper_item">
                <video playsinline="playsinline" autoplay loop muted preload="metadata">
                  <source ${src_val} type="video/mp4">
                </video>
              </div>
            </div>`;
          }
        });
        html += '</div>';

        if(this.arrows_buttons){
          html += '<div class="arrows_btn"><div class="ugc__swiper-button-prev swiper-button-prev"></div><div class="ugc__swiper-button-next swiper-button-next"></div></div>';
        }

        node.innerHTML = html;
        container.appendChild(node);

        let arrow_obj = false;
        if(this.arrows_buttons === true) {
          arrow_obj = {
            nextEl: node.querySelector('.ugc__swiper-button-next'),
            prevEl: node.querySelector('.ugc__swiper-button-prev'),
          }
        }

        const ugc_swiper = new Swiper(node, {
          slidesPerView: "auto",
          slidesPerGroupAuto: true,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumVelocityRatio: 1.2,
          },
          speed: 250,
          navigation: arrow_obj
        });

      }

      function populate_div(){
        const parent_container = options.current_script.parentElement;
        const container = document.createElement("div");
        container.classList.add("UGC_Gallery_Container");
        if(options.hide_title) {
          container.innerHTML += `<div class="ugc_media_area"></div>`;          
        }
        else {
          container.innerHTML += `<div class="fake_max_width_left_side"><h3 class="section_title_style_01">In je huis</h3></div><div class="ugc_media_area"></div>`;          
        }
        const ugc_container = container.querySelector(".ugc_media_area");

        if(pinterest_style_valid){
          container.classList.add("ugc_media_area_pint_container")
          const columns_ = ugc_gallery_design(refined_array, columns, ugc_container);
          columns_.forEach((col, index) => {
            if(col.length > 0) {

              let column;
              if(document.querySelector(`.ugc_column[data-column-num="${index}"]`)) {
                column = document.querySelector(`.ugc_column[data-column-num="${index}"]`)
              }
              else {
                column = document.createElement("div");
                column.classList.add("ugc_column");
                column.setAttribute("data-column-num", index);
              }

              ugc_container.appendChild(column);
              column.innerHTML = "";

              col.forEach(media => {
                let media_url = media.item.url;

                

                if(media.item.type == "img") {
                  column.innerHTML += `<div href="${media_url}" class="ugc_pint_item ugc_aspect_ratio_${media.item.aspect_ratio}" ${hide_by_default}><img src="${media_url}" width="600" alt="UGC Media"></div>`;
                }
                else if(media.item.type == "video") {
                  let src_val = `src="${media_url}"`;
                  if(lazy_load_video == true){
                    src_val = `src="" lazy_video_src="${media_url}"`;
                  }
                  column.innerHTML += `<div href="${media_url}" class="ugc_pint_item ugc_aspect_ratio_${media.item.aspect_ratio}" ${hide_by_default}><video playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="metadata"> <source ${src_val} type="video/mp4"> </video></div>`;
                }
              });

            }

          });
        }
        else {
          ugc_fallback_gallery_swiper(refined_array, ugc_container);
        }


        parent_container.appendChild(container);

      }


      make_refined_array();
      sort_array();
      check_valid();
      populate_div();

      document.dispatchEvent(new Event("UGC_Ready"));

    }
  }
  catch(err) {
    console.error(err);
  }

}


class BBModal {
  constructor(options){
    try {
      this.trigger_buttons = options.triggers;
      this.inner_content = options.modal_content;
      this.unique_tag = options.unique_tag;
      this.init();
    }
    catch(err) {
      console.log(err);
    }
  }
  init(){
    this.inner_content.style.display = "none";
    this.check_for_no_duplicates();
    this.create_modal_structure();
    this.addEvtListeners();
  }
  check_for_no_duplicates(){
    if(document.querySelector(`.BB_Main_modal[u_tag="${this.unique_tag}"]`)){
      const arr = document.querySelectorAll(`.BB_Main_modal[u_tag="${this.unique_tag}"]`);
      for(const bb_modal_main of arr) {
        bb_modal_main.remove();
      }
    }
  }
  create_modal_structure() {

      this.modal_html = document.createElement("div");
      this.modal_html.classList = "BB_Main_modal unactive";
      if(this.unique_tag) {
        this.modal_html.setAttribute("u_tag", this.unique_tag);
      }

      this.modal_html.innerHTML = `
          <div class="BB_modal_backdrop"></div>
          <div class="BB_modal__main">
              <button class="modal_closer_x">
              </button>
              <div class="content_outer">
                <div class="content_inner"></div>
              </div>
          </div>
      `;

      this.modal_html.querySelector(".content_inner").appendChild(this.inner_content);
      this.inner_content.style.display = "";


      document.body.appendChild(this.modal_html);
      this.modal_main = this.modal_html.querySelector(".BB_modal__main");
    
  }
  addEvtListeners() {
    // Initial Trigger Button Click
    if(this.trigger_buttons.length > 0) {
      console.log(`this.trigger_buttons`);
      console.log(this.trigger_buttons);
      this.trigger_buttons.forEach(trigger_btn => {
        trigger_btn.addEventListener("click", ()=> {
          this.toggle_display(true);
        });
      });
    }
    else {
      this.trigger_buttons.addEventListener("click", ()=> {
        this.toggle_display(true);
      });
    }


    /* - Modal Drag Close Functionality */

    const Drag_Close___TouchStart = (e) => {
      stretch = 0;

      if (this.modal_main.scrollTop < 20) {
        initial_y = e.touches[0].screenY;
        this.modal_main.addEventListener("touchmove", Drag_Close___TouchMove);
        this.modal_main.addEventListener("touchend", Drag_Close___TouchEnd);
      }
    };

    const Drag_Close___TouchMove = (e) => {
      const current_y = e.touches[0].screenY;

      if (current_y > initial_y + buffer) {
        stretch = (current_y - (initial_y + buffer)) / 2;
        this.modal_main.style.transform = `translateY(${stretch}px)`;
        this.modal_html.classList.add("moving");
      } else {
        stretch = 0;
        this.modal_html.classList.remove("moving");
        this.modal_main.style.transform = `translateY(0px)`;
      }
    };

    const Drag_Close___TouchEnd = () => {
      if (stretch > close_distance) {
        this.modal_html.classList.remove("moving");
        this.modal_main.style.transform = `translateY(1200px)`;
        this.toggle_display(false);

        setTimeout(() => {
          this.modal_main.style.transform = "";
        }, 600);
      } else {
        this.modal_html.classList.remove("moving");
        this.modal_main.style.transform = `translateY(0px)`;
      }

      this.modal_main.removeEventListener("touchmove", Drag_Close___TouchMove);
      this.modal_main.removeEventListener("touchend", Drag_Close___TouchEnd);
    };

    this.modal_main.addEventListener("touchstart", Drag_Close___TouchStart);
    var initial_y;
    const buffer = 50;
    const close_distance = 105;
    var stretch;

    this.modal_html.querySelector(".modal_closer_x").addEventListener("click", ()=> {

      this.modal_html.classList.remove("moving");
      this.modal_main.style.transform = `translateY(800px)`;
      this.toggle_display(false);

      setTimeout(() => {
        this.modal_main.style.transform = "";
      }, 600);
      this.toggle_display(false);
    });

    this.modal_html.querySelector(".BB_modal_backdrop").addEventListener("click", ()=> { this.toggle_display(false);});

  }

  toggle_display(bool) {
    if(bool) {
      document.body.style.overflow = "hidden";
      this.modal_html.classList.add("active");
      this.modal_html.classList.add("pre_enter");
      setTimeout(()=> { this.modal_html.classList.remove("pre_enter"); }, 100);

      if(window.Active_BBModal !== undefined) {
        window.Active_BBModal.toggle_display(false);
      }
      window.Active_BBModal = this;

    }
    else {
      this.modal_html.classList.add("leaving");
      document.body.style.overflow = "";

      setTimeout(() => {
        this.modal_html.classList.remove(
          "active",
          "leaving",
          "pre_enter",
          "moving"
        );
        window.Active_BBModal = undefined;
      }, 300);

      this.modal_main.classList.remove("extended");
    }
  }

}



// Recently Viewed New
(function(){
  // Populate Recently Viewed
  if(document.body.classList.contains("template-product")){
    if(localStorage.getItem("cookie_consent") === "granted") {
      populate_recently_viewed_slot();
    }
    else {
      document.addEventListener("Cookies_Accepted", populate_recently_viewed_slot);
    }
    function populate_recently_viewed_slot(){
      const product_string = document.location.pathname.replace("/products/", "");
      if(localStorage.getItem("recently_viewed_products") == null){
        localStorage.setItem("recently_viewed_products", product_string);
      }
      else {
        let RVP_ = localStorage.getItem("recently_viewed_products");
        RVP_ = RVP_.split(",");
        // Remove current item from array if exists
        if(RVP_.includes(product_string)){
          RVP_ = RVP_.filter(item => item !== product_string);
        }
        // Add to start of array
        RVP_.unshift(product_string);
        RVP_ = RVP_.slice(0, 6);
        const value = RVP_.toString();
        localStorage.setItem("recently_viewed_products", value);
      }
    }
  }

  const recently_view_ref = document.querySelector("#recently-viewed-products");
  if(recently_view_ref) {
    if(localStorage.getItem("cookie_consent") === "granted" && localStorage.getItem("recently_viewed_products")) {
        let RVP_ = localStorage.getItem("recently_viewed_products");
        RVP_ = RVP_.split(",");
        RVP_.forEach(prod => {
          const li = document.createElement("li");
          li.className = "product linked recently_viewed_item product-item__ tile";
          li.style.display = "none";
          recently_view_ref.appendChild(li);

          (async function(){          
            const url = document.location.origin + "/products/" + prod + ".json";
            const response = await fetch(url);
            if (!response.ok) {
              throw new Error("Unable to retrieve recently viewed product", (response.status))
            }
            const result = await response.json();
            populate_card(result.product);
          })();

          function populate_card(json){
            let price_;
            json.variants.forEach(variant => {
              const price = parseFloat(variant.price);
              if (typeof price_ === "undefined" || price_ > price) {
                price_ = variant.price;
              }
            });
            price_ = format_money_js(price_.toString(), "string");
            li.innerHTML = `
            <div class="product-card-figure">
              <a href="${window.location.origin}/products/${json.handle}">
                <img src="${(json.images[0].src.replace(".jpg", "_350x.jpg"))}">
              </a>
            </div>
            <div class="recentlyviewed_footer product-card-footer">
              <h3 class="brand">${json.vendor}</h3>
              <h3 class="title">
                <a href="${window.location.origin}/products/${json.handle}">${json.title}</a>
              </h3>
              <p class="price sale">${price_}</p>
            </div>
            `;
            li.style.display = "";
          }
        });
    }
    else {
      recently_view_ref.closest(".dpac_recently") ? recently_view_ref.closest(".dpac_recently").remove() : recently_view_ref.remove();
    }
  }

})();

